  console.log("VERSION:expanded email");
// Specific user's allowed email address
const allowedUserEmails = [
  "sukbumhong97@gmail.com",
  "llcfyo@gmail.com",
  "jotackett@beardsley.k12.ca.us",
  "elsi.mendez-lara@animo.org",
  "minishousene@gmail.com",
  "hlsabnani@hotmail.com",
  "compasseducationsolutions@gmail.com",
  "witcheta@pdsbnet.ca",
  "witcheta@pdsbnet.ca",
  "tomc@forcing.club",
  "jberes@rcps.info",
  "atzmath@gmail.com",
  "jcorippo@gmail.com",
  "dementiafriendlyfhls@gmail.com",
  "jessica.risko@gmail.com",
  "mayramartinez916@yahoo.com",
  "suzanneishere@gmail.com",
  "sb.mathinsights@gmail.com",
  "amyrowanteacher@gmail.com",
  "amikesell@icloud.com",
  "monumentallearningmlc@gmail.com",
  "rpriest@merit.academy",
  "Rpriest@merit.academy",
  "carole-ann.l'heureux@cssps.gouv.qc.ca",
  "aarole-ann.l'heureux@cssps.gouv.qc.ca",
  "benjaminchicky@gmail.com",
  "denise.huddlestun@gmail.com",
  "teedjvt@gmail.com",
  "seatonlilli@gmail.com",
  "sharonformanmath@gmail.com",
  "teachmcleod@gmail.com",
  "amylucenta@gmail.com",
  "mandyfisher.nbeast@gmail.com",
  "bethbradshaw2023@gmail.com",
  "amyleftmoore@gmail.com",
  "dcote0804@gmail.com",
  "nahaak@aol.com",
  "mbmathing@outlook.com",
  "skseabolt81@yahoo.com",
  "msxcary@aol.com",
  "TLKunkel01@gmail.com",
  "k_trechsler@hotmail.co.uk",
  "premiereaide@gmail.com",
  "jlopez827901@gmail.com",
  "ashantimcgrue@yahoo.com",
  "jen.moffettllc@gmail.com",
  "suehuhtalaharvey@gmail.com",

].map(email => email.toLowerCase()); // Convert all allowed emails to lowercase

const allowedDomains = [
  "school",
  "club",
  "info",
  "bank",
  "richmondconsolidated.org",
  "academy",
];
function getSourceAsDOM(url) {
  xmlhttp = new XMLHttpRequest();
  xmlhttp.open("GET", url, false);
  xmlhttp.send();
  parser = new DOMParser();
  return parser.parseFromString(xmlhttp.responseText, "text/html");
}

function isValidDateFormat(dateStr) {
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  return regex.test(dateStr);
}

console.log("aa");

function isValidDate(dateString) {
  const regex = /^\d{4}-\d{2}-\d{2}$/;

  if (!regex.test(dateString)) return false; // Invalid format

  const parts = dateString.split("-");
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const day = parseInt(parts[2], 10);

  if (year < 1000 || year > 3000 || month <= 0 || month > 12) return false;

  const maxDayCount = [
    31, // January
    (year % 4 == 0 && year % 100 != 0) || year % 400 == 0 ? 29 : 28, // February
    31, // March
    30, // April
    31, // May
    30, // June
    31, // July
    31, // August
    30, // September
    31, // October
    30, // November
    31, // December
  ][month - 1];

  return day > 0 && day <= maxDayCount;
}
const snapToTop = (() => {
  let mainEl, headerEl;

  function q(sel) { return document.querySelector(sel); }

  return function scrollToMainTop(extra = 16) {
    // Where we want to land (top of content, not absolute page 0)
    if (!mainEl)  mainEl  = q('#MainContent') || q('main') || q('.page-width');
    if (!headerEl) headerEl = q('#shopify-section-header') || q('.site-header') || q('header[role="banner"]');

    const headerH = headerEl ? headerEl.offsetHeight : 0;
    const mainTop = mainEl ? mainEl.getBoundingClientRect().top + window.pageYOffset : 0;
    const y = Math.max(mainTop - headerH - extra, 0);

    // If an anchor like #apply-now exists, it can yank you back down. Remove it.
    if (location.hash) history.replaceState(null, '', location.pathname + location.search);

    // Prevent a focused element from pulling the viewport down
    document.activeElement?.blur?.();

    // Clamp position now, on next paint, and after embeds (tweets) reflow
    const snap = () => window.scrollTo({ top: y, left: 0, behavior: 'auto' });
    snap();
    requestAnimationFrame(snap);
    setTimeout(snap, 300);
  };
})();


// Function to get URL parameters
function GetURLParameter(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

function ajax_mathreps(str) {
  const urlParams = new URLSearchParams(window.location.search);

  // Get all the form fields
  const email_field = $("#optin_request").val();
  const name_field = $("#optin_request_name").val();
  const company_field = $("#optin_request_company").val();
  const phone_field = $("#optin_request_phone").val();
  const twitter_field = $("#optin_request_twitter").val();
  const comments_field = $("#optin_request_comments").val();
  const check_field = $("#optin_request_check").val();
  const optin_btc_check = $("#optin_btc_check").is(":checked") ? "Yes" : "No";
  const landing_url = $("#landing_url").val();
  const optin_description = $("#optin_description").val();
  const optin_location = $("#optin_location").val();
  const optin_conference_type = $("#optin_conference_type").val();
  const optin_date = $("#optin_date").val();
  const optin_first_position = $("#optin_first_position").val();
  const optin_event = $("#optin_event").val();
  const optin_participants = $("#optin_participants").val();
  const optin_request_position = $("#optin_request_position").val();
  const utm_source_partner = $("#utm_source_partner").val();
  const utm_medium_partner = $("#utm_medium_partner").val();
  const utm_content_partner = $("#utm_content_partner").val();
  const utm_term_partner = $("#utm_term_partner").val();
  const utm_campaign_partner = $("#utm_campaign_partner").val();
  const optin_product = $("#optin_product").val(); // New product field

  // Shipping Information Fields
  const optin_first_name = $("#optin_first_name").val();
  const optin_last_name = $("#optin_last_name").val();
  const optin_country = $("#optin_country").val();
  const optin_organization = $("#optin_organization").val();
  const optin_address1 = $("#optin_address1").val();
  const optin_address2 = $("#optin_address2").val();
  const optin_city = $("#optin_city").val();
  const optin_state = $("#optin_state").val();
  const optin_zip = $("#optin_zip").val();
  const optin_phone = $("#optin_phone").val();

  // Override any UTM parameters from URL if they exist
  const utm_source =
    urlParams.get("utm_source") || $("#utm_source_partner").val();
  const utm_medium =
    urlParams.get("utm_medium") || $("#utm_medium_partner").val();
  const utm_campaign =
    urlParams.get("utm_campaign") || $("#utm_campaign_partner").val();
  const utm_content =
    urlParams.get("utm_content") || $("#utm_content_partner").val();
  const utm_term = urlParams.get("utm_term") || $("#utm_term_partner").val();

  // Validate Product Selection
  if (!optin_product) {
    $("#custom_form_error").html(
      "<center><p style='font-size:80%; color:red;'> <strong>Please select a product.</strong> </p></center>"
    );
    return; // Stop execution if product is not selected
  }
  console.log("optin product", optin_product);

  // Validate Shipping Information Fields
  if (
    !email_field ||
    !name_field ||
    !comments_field ||
    !optin_location ||
    !optin_participants ||
    !optin_request_position ||
    !optin_date ||
    !optin_event ||
    !comments_field ||
    !optin_description
  ) {
    $("#custom_form_error").html(
      "<center><p style='font-size:80%; color:red;'> <strong>Please fill out all the Event information fields.</strong> </p></center>"
    );
    return; // Stop execution if any shipping field is empty
  }

  // Validate Shipping Information Fields
  if (
    !optin_first_name ||
    !optin_last_name ||
    !optin_country ||
    !optin_organization ||
    !optin_address1 ||
    !optin_city ||
    !optin_state ||
    !optin_zip ||
    !optin_phone
  ) {
    $("#custom_form_error").html(
      "<center><p style='font-size:80%; color:red;'> <strong>Please fill out all the shipping information fields.</strong> </p></center>"
    );
    return; // Stop execution if any shipping field is empty
  }

  // Validate SMS Opt-In Checkbox
  const optin_sms = $("#optin_sms").is(":checked");
  if (!optin_sms) {
    $("#custom_form_error").html(
      "<center><p style='font-size:80%; color:red;'> <strong>You must agree to receive SMS messages to proceed.</strong> </p></center>"
    );
    return; // Stop execution if SMS opt-in is not checked
  }

  // Encode all fields for URL
  const encodedFields = {
    optin_request_name: encodeURI(name_field),
    optin_request: encodeURI(email_field),
    optin_request_company: encodeURI(company_field),
    optin_date: encodeURI(optin_date),
    optin_first_position: encodeURI(optin_first_position),
    optin_request_phone: encodeURI(phone_field),
    optin_event: encodeURI(optin_event),
    optin_participants: encodeURI(optin_participants),
    optin_request_twitter: encodeURI(twitter_field),
    optin_request_comments: encodeURI(comments_field),
    optin_request_check: encodeURI(check_field),
    landing_url: encodeURI(landing_url),
    utm_source_partner: encodeURIComponent(utm_source),
    utm_medium_partner: encodeURIComponent(utm_medium),
    utm_content_partner: encodeURIComponent(utm_content),
    utm_term_partner: encodeURIComponent(utm_term),
    utm_campaign_partner: encodeURIComponent(utm_campaign),
    optin_btc_check: encodeURI(optin_btc_check),
    optin_request_position: encodeURI(optin_request_position),
    optin_description: encodeURI(optin_description),
    optin_location: encodeURI(optin_location),
    optin_conference_type: encodeURI(optin_conference_type),
    optin_first_name: encodeURI(optin_first_name),
    optin_last_name: encodeURI(optin_last_name),
    optin_country: encodeURI(optin_country),
    optin_organization: encodeURI(optin_organization),
    optin_address1: encodeURI(optin_address1),
    optin_address2: encodeURI(optin_address2),
    optin_city: encodeURI(optin_city),
    optin_state: encodeURI(optin_state),
    optin_zip: encodeURI(optin_zip),
    optin_phone: encodeURI(optin_phone),
    optin_product: encodeURI(optin_product), // Include the new product field
  };

  // Validate Email Format
  const mailformat =
    /^(?!.*['"])\w+(?:['.-]?\w+)*@\w+(?:['.-]?\w+)*(\.\w{2,3})+$/;
  if (!email_field.match(mailformat)) {
    $("#custom_form_error").html(
      "<p style='font-size:80%;color:red;'> <strong>There is an issue with the email provided. Please add a valid work email. (i.e Email contains special character, avoid personal emails such as gmail, hotmail, etc). For more assistance please contact support@wipebook.com.</strong> </p>"
    );
    return; // Stop execution if email is invalid
  }

  // Validate Event Date
  if (!isValidDate(optin_date)) {
    $("#custom_form_error").html(
      "<center><p style='font-size:80%;'> <strong>There is an issue with your date format.</strong> </p></center>"
    );
    return; // Stop execution if date is invalid
  }

  // Check if the raffle checkbox is checked
  const raffleChecked = document.getElementById("optin_request_check").checked;
  if (!raffleChecked) {
    $("#custom_form_error").html(
      "<center><p style='font-size:80%; color:red;'> <strong>Thank you for your interest. To qualify for a free set of Wipebook flipcharts, you must agree to raffle a flipchart set to your attendees. If you're unable to do this, we won't be able to provide the flipcharts. <br></br> Thanks for understanding.</strong> </p></center>"
    );
    return; // Stop execution if raffle checkbox is not checked
  }

  // Submit the form data to Make.com
  const xhttp = new XMLHttpRequest();
  xhttp.open(
    "POST",
    "https://hook.us1.make.com/iau5pdb9iw1axnbfi6agsw7nggwh3dns"
  );
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhttp.send(
    Object.keys(encodedFields)
      .map((key) => `${key}=${encodedFields[key]}`)
      .join("&")
  );

  // Display success message
  $("#custom_form").html(
    "<center><p style='font-size:80%;'> <strong>Thanks for applying, you will receive an automated email from us within the hour. If you don't receive this please email after 1 hour please email us at support@wipebook.com. <br></br> If you have more events, please don't request any donations through the form right now. They will not be received. Please contact us at support@wipebook.com instead.</strong> </p></center>"
  );
}

// Helper function to validate date format
function isValidDate(dateString) {
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  if (!regex.test(dateString)) return false; // Check format
  const date = new Date(dateString);
  return !isNaN(date.getTime()); // Check if valid date
}


function ajax_workshops(str) {
    console.log("ajax_workshops function called - starting form submission");
    
    // Log browser and device information for debugging
    console.log("User Agent:", navigator.userAgent);
    console.log("Platform:", navigator.platform);
    console.log("Online status:", navigator.onLine);
    console.log("Connection type:", navigator.connection ? navigator.connection.effectiveType : "unknown");
    
    // const form = document.getElementById('make_partner');  // <- your actual form id
  
    // if (form) {
    //   // Trigger browser-native validation UI
    //   if (!form.reportValidity()) {
    //     $("#custom_form_error").html(
    //       "<center><p style='font-size:80%;'><strong>Please complete the missing fields.</strong></p></center>"
    //     );
    //     return; // STOP: don't send webhooks, don't change DOM
    //   }
    //   $("#custom_form_error").empty();
    // } else {
    //   console.error("Form with id 'make_partner' not found");
    // }
  
    const form = document.getElementById('make_partner');
     if (form) {
       if (!form.reportValidity()) {
         $("#custom_form_error").html("<center><p style='font-size:80%;'><strong>Please complete the missing fields.</strong></p></center>");
         return;
       }
       $("#custom_form_error").empty();
     }
  
  
    var email_field = $("#optin_request").val();
  
    var source = "partner";
  
    var sParam = "lnid";
    var valuelabel = GetURLParameter(sParam);
    var _this = this;
    var email_field = $("#optin_request").val();
    var name_field = $("#optin_request_name").val();
    var company_field = $("#optin_request_company").val();
    var phone_field = $("#optin_request_phone").val();
    var twitter_field = $("#optin_request_twitter").val();
    var comments_field = $("#optin_request_comments").val();
    var check_field = $("#optin_request_check").val();
    var optin_btc_check = $("#optin_btc_check").is(":checked") ? "BTC" : "NA";
    console.log("optin_btc_check", optin_btc_check);
  
    var landing_url = $("#landing_url").val();
    // var multiple_event_checkbox = $("#multiple_event_checkbox").val();
    // const multiEventChecked = document.getElementById(
    //   "multiple_event_checkbox"
    // ).checked;
  
    var name_field = encodeURI(name_field);
    var company_field = encodeURI(company_field);
    var phone_field = encodeURI(phone_field);
    var twitter_field = encodeURI(twitter_field);
    var comments_field = encodeURI(comments_field);
  
    var optin_description = encodeURI(": " + $("#optin_description").val());
    var optin_location = encodeURI("[" + $("#optin_location").val() + "]");
    var optin_conference_type = encodeURI(
      ": " + $("#optin_conference_type").val() + " "
    );
    var optin_request_name = encodeURI($("#optin_request_name").val());
    var optin_request = encodeURI($("#optin_request").val());
    var optin_request_company = encodeURI($("#optin_request_company").val());
    var optin_date = encodeURI($("#optin_date").val());
    var optin_first_position = encodeURI($("#optin_first_position").val());
    var optin_request_phone = encodeURI($("#optin_request_phone").val());
    var optin_event = encodeURI($("#optin_event").val());
    var optin_participants = encodeURI($("#optin_participants").val());
    var optin_request_twitter = encodeURI($("#optin_request_twitter").val());
    var optin_request_comments = encodeURI($("#optin_request_comments").val());
    var optin_request_check = encodeURI($("#optin_request_check").val());
    var landing_url = encodeURI($("#landing_url").val());
    var utm_source_partner = encodeURI($("#utm_source_partner").val());
    var utm_medium_partner = encodeURI($("#utm_medium_partner").val());
    var utm_content_partner = encodeURI($("#utm_content_partner").val());
    var utm_term_partner = encodeURI($("#utm_term_partner").val());
    var utm_campaign_partner = encodeURI($("#utm_campaign_partner").val());
    var optin_request_position = encodeURI($("#optin_request_position").val());
  
    var emailzer = $("#optin_request").val();
  
    var date_field = $("#optin_date").val();
    var event_field = $("#optin_event").val();
    var position_field = $("#optin_request_position").val();
    var participants_field = $("#optin_participants").val();
  
    email_field = email_field.replace(/ /g, "");
    optin_request_name = optin_request_name.replace(/\./g, "");
    optin_request_name = optin_request_name.replace(/'/g, "");
    optin_request_name = optin_request_name.replace(/-/g, "");
  
    document.getElementById("optin_request").value = email_field;
  
    var email_field = encodeURI(email_field);
  
    //var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    // var mailformat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    var mailformat =
      /^(?!.*['"])\w+(?:['.-]?\w+)*@\w+(?:['.-]?\w+)*(\.\w{2,3})+$/;
  
    //var mailformat = /^\w+(?:[.'-]?\w+)*@\w+(?:[.'-]?\w+)*(\.\w{2,3})+$/; allowing apostrohpe
  
    // List of strings to check against
    const stringList = [
      "gmx.com",
      "suddenlink.net",
      "cogeco.ca",
      "rr.com",
      "centurylink.net",
      "centurytel.net",
      "cs.com",
      "accesscomm.ca",
      "blackgold.ca",
      "icloud.com",
      "mac.com",
      "hotmail.fr",
      "me.com",
      "hotmail.ca",
      "aim.com",
      "shaw.ca",
      "rogers.com",
      "sympatico.ca",
      "videotron.ca",
      "live.com",
      "verizon.net",
      "yahoo.de",
      "telusplanet.net",
      "live.ca",
      "rocketmail.com",
      "xplornet.ca",
      "ymail.com",
      "yahoo.fr",
      "xtra.co.nz",
      "telus.net",
      "gmai.com",
      "sasktel.net",
      "prodigy.net",
      "email.com",
      "eastlink.ca",
      "mail.com",
      "gmail.co",
      "mailbox.org",
      "protonmail.com",
      "hotmil.com",
      "hormail.com",
      "gmaul.com",
      "yahoo.se",
      "yahoo.co",
      "gmailcom.com",
      "ns.sympatico.ca",
      "gmail.com",
      "comcast.net",
      "yahoo.com",
      "hotmail.com",
      "aol.com",
      "outlook.com",
      "hotmail.co.uk",
      "msn.com",
      "earthlink.net",
      "yahoo.ca",
      "hotmail.com.au",
      "yahoo.com.au",
      "yahoo.co.uk",
      "gmaol.com",
      "yahoo.com.tw",
      "1gmail.com",
      "yahoo.com.br",
      "yahoo.com.ph",
      "yahoo.com.sg",
      "yahoo.com.mx",
      "yahoo.com.hk",
      "outlook.com.au",
      "hotmail.com",
      "agmail.com",
      "7gmail.com",
      "gmail",
      "yahoo",
      "outlook",
      "rr.com",
      "earthlink.net",
      "msn.com",
      "aol",
      "protonmail",
      "icloud.com",
      "mac.com",
    ];
  
    // Extracting domain from email_field
    const emailDomain = email_field.split("@")[1];
    const domainParts = emailDomain.split(".");
    const topLevelDomain = domainParts[domainParts.length - 1];
  
    // Checking if the email domain exactly matches one of the domains in stringList
    const isAllowedDomain =
      stringList.includes(emailDomain) || allowedDomains.includes(topLevelDomain);
    console.log(isAllowedDomain);
    console.log(optin_request_check);
    const raffleChecked = document.getElementById("optin_request_check").checked;
    console.log(raffleChecked);
  
    const WB_LOADER_HTML = `
  <div style="
      display:flex;
      justify-content:center;
      gap:6px;
      margin:14px auto 14px auto;
      line-height:0;
      height:16px;         
      overflow:visible;  
    ">
      <span class="wb-dot" style="
        width:7px; height:7px; border-radius:999px; background:#0066cc;
        display:inline-block; animation: wb-bounce 0.8s ease-in-out infinite;
        animation-delay: 0s;
      "></span>
      <span class="wb-dot" style="
        width:7px; height:7px; border-radius:999px; background:#0066cc;
        display:inline-block; animation: wb-bounce 0.8s ease-in-out infinite;
        animation-delay: 0.1s;
      "></span>
      <span class="wb-dot" style="
        width:7px; height:7px; border-radius:999px; background:#0066cc;
        display:inline-block; animation: wb-bounce 0.8s ease-in-out infinite;
        animation-delay: 0.2s;
      "></span>
      <span class="wb-dot" style="
        width:7px; height:7px; border-radius:999px; background:#0066cc;
        display:inline-block; animation: wb-bounce 0.8s ease-in-out infinite;
        animation-delay: 0.3s;
      "></span>
      <span class="wb-dot" style="
        width:7px; height:7px; border-radius:999px; background:#0066cc;
        display:inline-block; animation: wb-bounce 0.8s ease-in-out infinite;
        animation-delay: 0.4s;
      "></span>
    </div>
    <style>
      @keyframes wb-bounce {
        0%, 100% { transform: translateY(0); opacity: 1; }
        50%      { transform: translateY(-4px); opacity: .6; }
      }
      @media (prefers-reduced-motion: reduce) {
        .wb-dot { animation: none !important; }
      }
    </style>`;
  
    // Helper to keep status messages from collapsing into surrounding content, especially on mobile.
    function renderSubmissionStatusMessage(messageHtml, includeLoader = false) {
      const trimmedMessage = (messageHtml || "").trim();
      const isMobileView = window.matchMedia("(max-width: 768px)").matches;
      const containerPadding = isMobileView ? "32px 18px 48px" : "48px 0 56px";
      const containerStyles = [
        "text-align:center",
        "width:100%",
        "box-sizing:border-box",
        `padding:${containerPadding}`
      ].join(";");
      const loaderMarkup = includeLoader ? WB_LOADER_HTML : "";
  
      $("#custom_form").html(`
        <div class="submission-status-message" style="${containerStyles}">
          <p style="font-size:80%; color:#0066cc; margin:0; line-height:1.5;">
            ${trimmedMessage}
          </p>
          ${loaderMarkup}
        </div>
      `);
    }
  
    if (isValidDate(optin_date)) {
      // added allowed emails as a check
      if (
        (email_field.match(mailformat) && !isAllowedDomain) ||
        (email_field.match(mailformat) &&
          allowedUserEmails.includes(email_field)) ||
        allowedDomains.includes(emailDomain.split(".").slice(-1)[0])
      ) {
        if (raffleChecked) {
          if (
            name_field &&
            date_field &&
            event_field &&
            position_field &&
            participants_field &&
            comments_field
          ) {
            // Show loading message instead of immediate success
   $("#custom_form").html(`
  
              <center><p style='font-size:20px; color: #0066cc;'><strong>Submitting your request... Please wait.</strong></p>   ${WB_LOADER_HTML}</center>
  `);
  snapToTop();
  
            console.log("Form validation passed - submitting to Make.com webhooks");
            
            // Get the current URL for partner parameter - MOVED UP to define partner variable
            const urlParams = new URLSearchParams(window.location.search);
            const partner = urlParams.get("partner");
            console.log("partner", partner);
            
            // Log form data for debugging
            console.log("Form data:", {
              email: email_field,
              name: name_field,
              company: company_field,
              date: date_field,
              event: event_field,
              position: position_field,
              participants: participants_field,
              comments: comments_field,
              partner: partner,
              userAgent: navigator.userAgent,
              timestamp: new Date().toISOString()
            });
  
            // Create promise-based function for better error handling with retry mechanism
            function sendToMakeWebhook(url, data, description, retryCount = 0) {
              const maxRetries = 2;
              
              return new Promise((resolve, reject) => {
                console.log(`Sending request to ${description} (attempt ${retryCount + 1}/${maxRetries + 1}): ${url}`);
                console.log(`Request data length: ${data.length} characters`);
                
                const xhr = new XMLHttpRequest();
                let timeoutId;
                
                // Set up timeout (30 seconds)
                timeoutId = setTimeout(() => {
                  xhr.abort();
                  const errorMsg = `Timeout: ${description} request took too long (attempt ${retryCount + 1})`;
                  console.error(errorMsg);
                  
                  if (retryCount < maxRetries) {
                    console.log(`Retrying ${description} in 2 seconds...`);
                    setTimeout(() => {
                      sendToMakeWebhook(url, data, description, retryCount + 1)
                        .then(resolve)
                        .catch(reject);
                    }, 2000);
                  } else {
                    reject(new Error(errorMsg));
                  }
                }, 30000);
                
                xhr.onload = function() {
                  clearTimeout(timeoutId);
                  console.log(`${description} response status: ${xhr.status}`);
                  console.log(`${description} response: ${xhr.responseText}`);
                  
                  if (xhr.status >= 200 && xhr.status < 300) {
                    // Make.com webhooks typically return 200 with "Accepted", or similar
                    // This only means the webhook received the data, not that it processed successfully
                    const response = xhr.responseText;
                    console.log(`${description} webhook accepted data. Response: "${response}"`);
                    
                    // For Make.com, a 200 status is the best we can get for immediate confirmation
                    // The actual processing happens asynchronously in Make.com
                    resolve({
                      status: 'accepted',
                      response: response,
                      timestamp: new Date().toISOString()
                    });
                  } else {
                    const errorMsg = `${description} HTTP error: ${xhr.status} - ${xhr.statusText}`;
                    console.error(errorMsg);
                    
                    if (retryCount < maxRetries && xhr.status >= 500) {
                      // Retry server errors
                      console.log(`Retrying ${description} in 2 seconds...`);
                      setTimeout(() => {
                        sendToMakeWebhook(url, data, description, retryCount + 1)
                          .then(resolve)
                          .catch(reject);
                      }, 2000);
                    } else {
                      reject(new Error(errorMsg));
                    }
                  }
                };
                
                xhr.onerror = function() {
                  clearTimeout(timeoutId);
                  const errorMsg = `${description} network error - please check your internet connection (attempt ${retryCount + 1})`;
                  console.error(errorMsg);
                  
                  if (retryCount < maxRetries) {
                    console.log(`Retrying ${description} in 2 seconds...`);
                    setTimeout(() => {
                      sendToMakeWebhook(url, data, description, retryCount + 1)
                        .then(resolve)
                        .catch(reject);
                    }, 2000);
                  } else {
                    reject(new Error(errorMsg));
                  }
                };
                
                xhr.onabort = function() {
                  clearTimeout(timeoutId);
                  const errorMsg = `${description} request was aborted (attempt ${retryCount + 1})`;
                  console.error(errorMsg);
                  
                  if (retryCount < maxRetries) {
                    console.log(`Retrying ${description} in 2 seconds...`);
                    setTimeout(() => {
                      sendToMakeWebhook(url, data, description, retryCount + 1)
                        .then(resolve)
                        .catch(reject);
                    }, 2000);
                  } else {
                    reject(new Error(errorMsg));
                  }
                };
                
                try {
                  console.log(`${description} - About to send XMLHttpRequest`);
                  console.log(`${description} - URL: ${url}`);
                  console.log(`${description} - Data preview: ${data.substring(0, 200)}...`);
                  
                  xhr.open("POST", url, true);
                  xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                  
                  console.log(`${description} - XMLHttpRequest configured, sending data...`);
                  xhr.send(data);
                  console.log(`${description} - XMLHttpRequest.send() called successfully`);
                } catch (error) {
                  clearTimeout(timeoutId);
                  const errorMsg = `${description} failed to send: ${error.message}`;
                  console.error(errorMsg);
                  
                  if (retryCount < maxRetries) {
                    console.log(`Retrying ${description} in 2 seconds...`);
                    setTimeout(() => {
                      sendToMakeWebhook(url, data, description, retryCount + 1)
                        .then(resolve)
                        .catch(reject);
                    }, 2000);
                  } else {
                    reject(new Error(errorMsg));
                  }
                }
              });
            }
  
            // Get the current URL for partner parameter - ALREADY DEFINED ABOVE
            // const urlParams = new URLSearchParams(window.location.search);
            // const partner = urlParams.get("partner");
            // console.log("partner", partner);
            
            // Add the 'partner' parameter to the API request if it exists
            const partnerParam = partner ? "&partner=" + partner : "";
  
            console.log("=== FORM FIELD VALUES ===");
            console.log("Raw field values:");
            console.log("  email_field:", email_field);
            console.log("  name_field:", name_field);
            console.log("  company_field:", company_field);
            console.log("  date_field:", date_field);
            console.log("  event_field:", event_field);
            console.log("  position_field:", position_field);
            console.log("  participants_field:", participants_field);
            console.log("  comments_field:", comments_field);
            console.log("Encoded values:");
            console.log("  optin_request_name:", optin_request_name);
            console.log("  optin_request:", optin_request);
            console.log("  optin_request_company:", optin_request_company);
            console.log("  optin_date:", optin_date);
            console.log("  optin_event:", optin_event);
            console.log("  optin_request_position:", optin_request_position);
            console.log("  optin_participants:", optin_participants);
            console.log("=== END FIELD VALUES ===");
  
            const requestData = 
              "optin_request_name=" +
                optin_request_name +
                "&optin_request=" +
                email_field +
                "&optin_request_company=" +
                optin_request_company +
                "&optin_date=" +
                optin_date +
                "&optin_first_position=" +
                optin_first_position +
                "&optin_request_phone=" +
                optin_request_phone +
                "&optin_event=" +
                optin_event +
                "&optin_participants=" +
                optin_participants +
                "&optin_request_twitter=" +
                optin_request_twitter +
                "&optin_request_comments=" +
                optin_location +
                optin_conference_type +
                optin_request_comments +
                optin_description +
                "&landing_url=" +
                landing_url +
                "&utm_source_partner=" +
                utm_source_partner +
                "&utm_medium_partner=" +
                utm_medium_partner +
                "&utm_content_partner=" +
                utm_content_partner +
                "&utm_term_partner=" +
                utm_term_partner +
                "&utm_campaign_partner=" +
                utm_campaign_partner +
                "&optin_btc_check=" +
                optin_btc_check +
                "&optin_request_check=" +
                optin_request_check +
                "&optin_request_position=" +
                optin_request_position +
                partnerParam;
  
            console.log("=== WEBHOOK DATA DEBUG ===");
            console.log("Complete request data being sent:", requestData);
            console.log("Request data length:", requestData.length);
            console.log("Webhook URLs:");
            console.log("  1. Workshop Additional Field Pre-Req:", "https://hook.us1.make.com/kimrsnp3sa6j12hle66k1yctg9mdwj38");
            console.log("  2. Workshop JS no pipeline:", "https://hook.us1.make.com/4ocer96nrhok2tpum8m00svyixu3qz29");
            console.log("=== END DEBUG ===");
  
            // Send to both webhooks with proper error handling
            const webhook1Promise = sendToMakeWebhook(
              "https://hook.us1.make.com/kimrsnp3sa6j12hle66k1yctg9mdwj38",
              requestData,
              "Workshop Additional Field Pre-Req workflow"
            );
            
            const webhook2Promise = sendToMakeWebhook(
              "https://hook.us1.make.com/4ocer96nrhok2tpum8m00svyixu3qz29",
              requestData,
              "Workshop JS no pipeline"
            );
  
            // Wait for both webhooks to complete
            // Note: Make.com webhooks only confirm receipt, not successful processing
            Promise.allSettled([webhook1Promise, webhook2Promise])
              .then(results => {
                console.log("Webhook submission attempts completed");
                
                let webhookSuccessCount = 0;
                let webhookErrors = [];
                
                results.forEach((result, index) => {
                  const webhookName = index === 0 ? "Workshop Additional Field Pre-Req" : "Workshop JS no pipeline";
                  
                  if (result.status === 'fulfilled') {
                    console.log(`${webhookName} webhook accepted data (received 200 response)`);
                    webhookSuccessCount++;
                  } else {
                    console.error(`${webhookName} webhook failed to accept data:`, result.reason.message);
                    webhookErrors.push(`${webhookName}: ${result.reason.message}`);
                  }
                });
                
                // Show appropriate message based on webhook acceptance.
                if (webhookSuccessCount > 0) {
                  console.log(`${webhookSuccessCount}/2 webhooks accepted the submission data`);
                  
                  // Create unique reference ID for tracking
                  const referenceId = `WS${Date.now()}${Math.random().toString(36).substr(2, 4).toUpperCase()}`;
                  const decision = getWorkshopDecision();
                  // Show simplified status message 
                  let statusMessage;
                  if (webhookSuccessCount === 2) {
                    if (decision === "approved"){
                      statusMessage = `
                      <strong style="font-size: 20px;">Please wait...</strong>
                    `;
                    } else{
                      statusMessage = `
                      <strong style="font-size: 20px;">Thank you for your request. Your request has been submitted.</strong>
                    `;
                    }
                    
                  } else {
                    statusMessage = `
                      <strong>⚠️ Your workshop request was submitted with a partial system issue.</strong><br><br>
                      Please contact us at support@wipebook.com and mention there was a partial submission issue.<br><br>
                      <strong>Reference ID:</strong> ${referenceId}<br><br>
                      <small>Technical note: 1 of 2 submission systems confirmed receipt.</small>
                    `;
                    
                    // Log partial failure for debugging
                    logFailureForDebugging({
                      type: 'partial_webhook_failure',
                      referenceId: referenceId,
                      email: email_field,
                      errors: webhookErrors,
                      successCount: webhookSuccessCount,
                      timestamp: new Date().toISOString(),
                      userAgent: navigator.userAgent,
                      url: window.location.href
                    });
                  }
                  const shouldShowLoader = decision === "approved";
                  renderSubmissionStatusMessage(statusMessage, shouldShowLoader);
                  snapToTop();
                  // Store reference ID in localStorage for potential follow-up
                  try {
                    localStorage.setItem('workshopSubmissionRef', JSON.stringify({
                      referenceId: referenceId,
                      email: email_field,
                      timestamp: new Date().toISOString(),
                      webhookSuccessCount: webhookSuccessCount
                    }));
                  } catch (e) {
                    console.log("Could not store reference in localStorage:", e);
                  }
                  
                  // Handle redirect logic after a brief delay to let user see the message
                  setTimeout(() => {
                    handleSuccessfulSubmission();
                  }, 2000);
                  
                } else {
                  // Both webhooks failed to accept data - clear connection/network issue
                  console.error("All webhooks failed to accept data:", webhookErrors);
                  
                  logFailureForDebugging({
                    type: 'complete_webhook_failure',
                    email: email_field,
                    errors: webhookErrors,
                    formData: {
                      name: name_field,
                      company: company_field,
                      date: date_field,
                      event: event_field,
                      position: position_field,
                      participants: participants_field
                    },
                    timestamp: new Date().toISOString(),
                    userAgent: navigator.userAgent,
                    url: window.location.href,
                    connection: navigator.connection ? navigator.connection.effectiveType : "unknown"
                  });
                  
                  $("#custom_form").html(`
                    <center>
                      <p style='font-size:80%; color: red;'>
                        <strong>❌ Submission Failed</strong><br><br>
                        We were unable to submit your workshop request due to a technical issue.<br>
                        This could be due to network connectivity or server problems.<br><br>
                        <strong>Please try again in a few minutes, or email us directly at:</strong><br>
                        <a href="mailto:support@wipebook.com">support@wipebook.com</a><br><br>
                        <small>Technical details: ${webhookErrors.join('; ')}</small>
                      </p>
                    </center>
                  `);
                }
              })
              .catch(error => {
                // This shouldn't happen with Promise.allSettled, but just in case
                console.error("Unexpected error in webhook processing:", error);
                
                logFailureForDebugging({
                  type: 'unexpected_error',
                  email: email_field,
                  error: error.message,
                  timestamp: new Date().toISOString(),
                  userAgent: navigator.userAgent,
                  url: window.location.href
                });
                
                $("#custom_form").html(`
                  <center>
                    <p style='font-size:80%; color: red;'>
                      <strong>❌ An unexpected error occurred</strong><br><br>
                      Please try again or contact support@wipebook.com<br><br>
                      <small>Error details: ${error.message}</small>
                    </p>
                  </center>
                `);
              });
  
            // Function to log failures for debugging (sends to a separate logging webhook)
            function logFailureForDebugging(errorData) {
              try {
                console.log("Logging failure for debugging:", errorData);
                
                const debugXhr = new XMLHttpRequest();
                debugXhr.open("POST", "https://webhook.site/unique-url-for-debugging", true); // Replace with actual debug webhook
                debugXhr.setRequestHeader("Content-type", "application/json");
                
                // Don't block the UI if debug logging fails
                debugXhr.onerror = function() {
                  console.log("Debug logging failed (non-critical)");
                };
                
                debugXhr.send(JSON.stringify(errorData));
              } catch (debugError) {
                console.log("Debug logging error (non-critical):", debugError);
              }
            }
  
            function getWorkshopDecision() {
              const optinDate = new Date(optin_date);
              const today = new Date();
              const next3Weeks = new Date(today.getTime() + 13 * 24 * 60 * 60 * 1000);
  
              const teacherNoBtc =
                optin_request_position.includes("Teacher") && optin_btc_check === "NA";
  
              const meetsStandardCriteria =
                Number(optin_participants) > 20 &&
                optin_request_position !== "Non-Educator" &&
                optin_request_comments !== "Students" &&
                optinDate >= next3Weeks;
              
              const privilegedPositions = ["Admin", "Coach", "Consultant", "Principal"];
              const isPrivilegedPosition = privilegedPositions.some((p) =>
                (optin_request_position || "").includes(p)
              );
  
              if (isPrivilegedPosition) {
                // Privileged positions: approve for all conditions EXCEPT
                // 1) Audience is Students
                // 2) Event date is before the existing cutoff (next3Weeks)
                if (optin_request_comments === "Students" || optinDate < next3Weeks) {
                  return "denied";
                }
                return "approved";
              }
              
              if (teacherNoBtc || meetsStandardCriteria || partner) {
                return "approved";
              }
  
              return "denied";
            }
  
            // Function to handle successful submission redirect logic
            function handleSuccessfulSubmission() {
              // today's date + 3 weeks
              var today = new Date();
              var next3Weeks = new Date(today.getTime() + 13 * 24 * 60 * 60 * 1000);
              console.log("CUTOFFDATE:" + next3Weeks);
  
              // Convert optin_date to a comparable format
              var optin_date_convert = new Date(optin_date);
              console.log("EVENTDATE:" + optin_date_convert);
  
              // Build agreement URL
              let redirectUrl = `${window.location.origin}/agreement?approved=${email_field}`;
  
              // Add UTM parameters to preserve campaign tracking
              const utmSource = $("#utm_source_partner").val() || 'partners';
              const utmMedium = $("#utm_medium_partner").val() || 'workshops';
              const utmCampaign = $("#utm_campaign_partner").val() || '';
              const utmContent = $("#utm_content_partner").val() || 'agreement';
              const utmTerm = $("#utm_term_partner").val() || '';
  
              redirectUrl += `&utm_source=${encodeURIComponent(utmSource)}`;
              redirectUrl += `&utm_medium=${encodeURIComponent(utmMedium)}`;
              if (utmCampaign) redirectUrl += `&utm_campaign=${encodeURIComponent(utmCampaign)}`;
              redirectUrl += `&utm_content=${encodeURIComponent(utmContent)}`;
              if (utmTerm) redirectUrl += `&utm_term=${encodeURIComponent(utmTerm)}`;
  
              if (partner) {
                redirectUrl += `&partner=${partner}`;
              }
  
              // Privileged positions: redirect only when the privileged approval conditions are met.
              const privilegedPositions = ["Admin", "Coach", "Consultant", "Principal"];
              const isPrivilegedPosition = privilegedPositions.some((p) =>
                (optin_request_position || "").includes(p)
              );
              if (isPrivilegedPosition) {
                if (optin_request_comments !== "Students" && optin_date_convert >= next3Weeks) {
                  console.log("Privileged position approved — redirecting in same tab.");
                  window.location.href = redirectUrl;
                } else {
                  console.log("Privileged position denied — staying on page.");
                }
                return;
              }

              // Check if the participant is a Teacher and did not opt in for BTC
              if (
                optin_request_position.includes("Teacher") &&  // position contains "Teacher"
                optin_btc_check === "NA"                       // BTC opt-in is "No"/"NA"
              ) {
                // BEFORE: window.open(redirectUrl, '_blank');
                // NOW: render in the same page
                console.log("Teacher without BTC — redirecting in same tab to agreement page.");
                window.location.href = redirectUrl;
                return;
              }
  
              // Other approval logic
              if (
                Number(optin_participants) > 20 &&              // participants > 20
                optin_request_position !== "Non-Educator" &&    // position NOT "Non-Educator"
                optin_request_comments !== "Students" &&        // audience NOT "Students"
                optin_date_convert >= next3Weeks // event >= 3-week window
              ) {
                // BEFORE: window.open(redirectUrl, '_blank');
                // NOW: render in the same page
                console.log("All approval conditions met — redirecting in same tab.");
                window.location.href = redirectUrl;
              } else if (partner) {
                // partner-specific logic
                // BEFORE: window.open(redirectUrl, '_blank');
                // NOW: render in the same page
                console.log("Partner submission — redirecting in same tab.");
                window.location.href = redirectUrl;
              } else {
                // Conditions not met — keep current behavior (stay on page / show message)
                console.log("Conditions not met for direct agreement render — staying on page.");
              }
            }
            
          } else {
            console.log();
  
            $("#custom_form_error").html(
              "<center><p style='font-size:80%;'> <strong>Please complete the missing fields. </strong> </p></center>"
            );
          }
        } else {
          $("#custom_form_error").html(
            "<center><p style='font-size:80%; color:red;'> <strong>Thank you for your interest. To qualify for a free set of Wipebook flipcharts, you must agree to raffle a flipchart set to your attendees. If you’re unable to do this, we won’t be able to provide the flipcharts. <br></br> Thanks for understanding.</strong> </p></center>"
          );
        }
      } else {
        $("#custom_form_error").html(
          "<p style='font-size:80%;color:red;'> <strong>There is an issue with the email provided. Please add a valid work email. (i.e Email contains special character, avoid personal emails such as gmail, hotmail, etc). For more assistance please contact support@wipebook.com.</strong> </p>"
        );
  
        //INSERT THE POST REQUEST TO ADD TO DB ANYWAYS
  
        if (email_field.match(mailformat)) {
          const xhttp = new XMLHttpRequest();
          xhttp.onload = function () {
            console.log(xhttp.responseText);
          };
  
          let fullName = optin_request_name; // Replace this with your actual variable
  
          const names = fullName.split("%20");
          const firstName = names[0];
          const lastName = names[names.length - 1];
  
          console.log(`First name: ${firstName}`);
          console.log(`Last name: ${lastName}`);
  
          // firstName and lastName now contain the split name
          console.log(firstName + "|"); // Outputs: Frank
          console.log(lastName); // Outputs: Bouchard
  
          // goes to Contact Sync workflow
          xhttp.open(
            "POST",
            "https://hook.us1.make.com/wfjw095lwzcf4v3s5j4g4ud2low5kt5p"
          );
          xhttp.setRequestHeader(
            "Content-type",
            "application/x-www-form-urlencoded"
          );
          xhttp.send(
            "first_name=" +
              firstName +
              "&last_name=" +
              lastName +
              "&optin_request=" +
              email_field +
              "&optin_request_company=" +
              optin_request_company +
              "&optin_date=" +
              optin_date +
              "&position=" +
              optin_request_position +
              "&optin_request_phone=" +
              optin_request_phone +
              "&optin_event=" +
              optin_event +
              "&optin_participants=" +
              optin_participants +
              "&optin_request_twitter=" +
              optin_request_twitter +
              "&optin_request_comments=" +
              optin_location +
              optin_conference_type +
              optin_request_comments +
              optin_description +
              "&landing_url=" +
              landing_url +
              "&utm_source=" +
              utm_source_partner +
              "&utm_medium=" +
              utm_medium_partner +
              "&utm_campaign=" +
              utm_campaign_partner +
              "&utm_content=" +
              utm_content_partner +
              "&utm_term=" +
              utm_term_partner +
              "&optin_btc_check=" +
              optin_btc_check + // Added BTC opt-in field
              "&optin_request_check=" +
              optin_request_check +
              // "&multiple_event_checkbox=" +
              // multiEventChecked + // Send the new checkbox value
              "&customer_type=duplicate_personal&optin_request_position=" +
              optin_request_position
          );
        }
      }
    } else {
      $("#custom_form_error").html(
        "<center><p style='font-size:80%;'> <strong>There is an issue with your date format.</strong> </p></center>"
      );
    }
  }
  
let _workshopSubmitting = false;

function ajax_new_workshops(str) {
  console.log("ajax_new_workshops function called - starting form submission");

  // Prevent duplicate submissions
  if (_workshopSubmitting) {
    console.log("ajax_new_workshops: submission already in progress, ignoring duplicate call");
    return;
  }
  _workshopSubmitting = true;

  // Disable the submit button visually
  const submitBtn = document.querySelector('a[onclick*="ajax_new_workshops"]');
  if (submitBtn) {
    submitBtn.style.pointerEvents = "none";
    submitBtn.style.opacity = "0.5";
    submitBtn.style.cursor = "not-allowed";
  }
  
  // Log browser and device information for debugging
  console.log("User Agent:", navigator.userAgent);
  console.log("Platform:", navigator.platform);
  console.log("Online status:", navigator.onLine);
  console.log("Connection type:", navigator.connection ? navigator.connection.effectiveType : "unknown");


  // === BLOCK ON MISSING/INVALID FIELDS (except Address 2) ===
  const form = document.getElementById('submit_form');

  // Make Address 2 optional (belt & suspenders)
  document.getElementById('optin_address2')?.removeAttribute('required');

  // Fill hidden fields first so they validate/submit correctly
  try { ensureTimezone(); } catch (e) {}
  try { computeAndSetOptinDateTimeForET(); } catch (e) {}



  // Trigger native bubbles; STOP if anything required is missing/invalid
  if (!form.reportValidity()) {
    $("#custom_form_error").html(
      "<center><p style='font-size:80%;'><strong>Please complete the missing fields.</strong></p></center>"
    );
    // Reset submit guard so user can fix errors and resubmit
    _workshopSubmitting = false;
    if (submitBtn) {
      submitBtn.style.pointerEvents = "";
      submitBtn.style.opacity = "";
      submitBtn.style.cursor = "";
    }
    return; // <-- prevents webhook calls & DOM changes
  }
  $("#custom_form_error").empty();

  // Capture shipping field values before modifying the DOM
  var ship_first_name   = $("#optin_first_name").val();
  var ship_last_name    = $("#optin_last_name").val();
  var ship_address1     = $("#optin_address1").val();
  var ship_address2     = $("#optin_address2").val();
  var ship_country      = $("#optin_country").val();
  var ship_city         = $("#optin_city").val();
  var ship_state        = $("#optin_state").val();
  var ship_zip          = $("#optin_zip").val();
  var ship_phone        = $("#optin_phone").val();
  var ship_organization = $("#optin_organization").val();
  var email_field = $("#optin_request").val();

  var source = "partner";

  var sParam = "lnid";
  var valuelabel = GetURLParameter(sParam);
  var _this = this;
  var email_field = $("#optin_request").val();
  var name_field = $("#optin_request_name").val();
  var company_field = $("#optin_request_company").val();
  var phone_field = $("#optin_request_phone").val();
  var twitter_field = $("#optin_request_twitter").val();
  var comments_field = $("#optin_request_comments").val();
  var check_field = $("#optin_request_check").val();
  // var optin_btc_check = $("#optin_btc_check").is(":checked") ? "Yes" : "No";
  var optin_btc_check = $("#optin_btc_check").val();
  if (optin_btc_check === "None of the above") {
    optin_btc_check = "NA";
  }


  console.log("optin_btc_check", optin_btc_check);
  
  var landing_url = $("#landing_url").val();
  // var multiple_event_checkbox = $("#multiple_event_checkbox").val();
  // const multiEventChecked = document.getElementById(
  //   "multiple_event_checkbox"
  // ).checked;

  var name_field = encodeURI(name_field);
  var company_field = encodeURI(company_field);
  var phone_field = encodeURI(phone_field);
  var twitter_field = encodeURI(twitter_field);
  var comments_field = encodeURI(comments_field);

  var optin_description = encodeURI(": " + $("#optin_description").val());
  var optin_location = encodeURI("[" + $("#optin_location").val() + "]");
  var optin_conference_type = encodeURI(
    ": " + $("#optin_conference_type").val() + " "
  );
  var optin_request_name = encodeURI($("#optin_request_name").val());
  var optin_request = encodeURI($("#optin_request").val());
  var optin_request_company = encodeURI($("#optin_request_company").val());
  var optin_date = encodeURI($("#optin_date").val());
  var optin_first_position = encodeURI($("#optin_first_position").val());

  var rawRequestPhone = $("#optin_request_phone").val().trim() || $("#optin_phone").val().trim();
  var optin_request_phone = encodeURIComponent(rawRequestPhone);

  var optin_event = encodeURI($("#optin_event").val());
  var optin_participants = encodeURI($("#optin_participants").val());
  var optin_request_twitter = encodeURI($("#optin_request_twitter").val());
  var optin_request_comments = encodeURI($("#optin_request_comments").val());
  var optin_request_check = encodeURI($("#optin_request_check").val());
  var landing_url = encodeURI($("#landing_url").val());
  var utm_source_partner = encodeURI($("#utm_source_partner").val());
  var utm_medium_partner = encodeURI($("#utm_medium_partner").val());
  var utm_content_partner = encodeURI($("#utm_content_partner").val());
  var utm_term_partner = encodeURI($("#utm_term_partner").val());
  var utm_campaign_partner = encodeURI($("#utm_campaign_partner").val());
  var optin_request_position = encodeURI($("#optin_request_position").val());

  var emailzer = $("#optin_request").val();

  var date_field = $("#optin_date").val();
  var event_field = $("#optin_event").val();
  var position_field = $("#optin_request_position").val();
  var participants_field = $("#optin_participants").val();

  var optin_time             = encodeURI($("#optin_time").val());
  // var optin_timezone         = encodeURI($("#optin_timezone").val());
  var optin_timezone  = encodeURIComponent($("#optin_timezone").val());
  var optin_product_variant = encodeURI($("#optin_product").val());
  var optin_sms_optin        = encodeURI( $("#optin_sms").is(":checked") ? "Yes" : "No" );
  // var collection_id = $("#collection_id").val();
  var collection_id =
  (document.getElementById("collection_id") && document.getElementById("collection_id").value) ||
  new URLSearchParams(location.search).get("cid") ||
  "";
  console.log("collection_id ", collection_id)
  var draft_source  = $("#draft_source").val();
  var where_source  = $("#where_source").val();
  var line_items    = $("#line_items").val();
  var ship          = $("#ship").val();
  var optin_datetime  = encodeURIComponent($("#optin_datetime").val());

  email_field = email_field.replace(/ /g, "");
  optin_request_name = optin_request_name.replace(/\./g, "");
  optin_request_name = optin_request_name.replace(/'/g, "");
  optin_request_name = optin_request_name.replace(/-/g, "");

  document.getElementById("optin_request").value = email_field;

  var email_field = encodeURI(email_field);

  //var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  // var mailformat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  var mailformat =
    /^(?!.*['"])\w+(?:['.-]?\w+)*@\w+(?:['.-]?\w+)*(\.\w{2,3})+$/;

  //var mailformat = /^\w+(?:[.'-]?\w+)*@\w+(?:[.'-]?\w+)*(\.\w{2,3})+$/; allowing apostrohpe

  // List of strings to check against
  const stringList = [
    "gmx.com",
    "suddenlink.net",
    "cogeco.ca",
    "rr.com",
    "centurylink.net",
    "centurytel.net",
    "cs.com",
    "accesscomm.ca",
    "blackgold.ca",
    "icloud.com",
    "mac.com",
    "hotmail.fr",
    "me.com",
    "hotmail.ca",
    "aim.com",
    "shaw.ca",
    "rogers.com",
    "sympatico.ca",
    "videotron.ca",
    "live.com",
    "verizon.net",
    "yahoo.de",
    "telusplanet.net",
    "live.ca",
    "rocketmail.com",
    "xplornet.ca",
    "ymail.com",
    "yahoo.fr",
    "xtra.co.nz",
    "telus.net",
    "gmai.com",
    "sasktel.net",
    "prodigy.net",
    "email.com",
    "eastlink.ca",
    "mail.com",
    "gmail.co",
    "mailbox.org",
    "protonmail.com",
    "hotmil.com",
    "hormail.com",
    "gmaul.com",
    "yahoo.se",
    "yahoo.co",
    "gmailcom.com",
    "ns.sympatico.ca",
    "gmail.com",
    "comcast.net",
    "yahoo.com",
    "hotmail.com",
    "aol.com",
    "outlook.com",
    "hotmail.co.uk",
    "msn.com",
    "earthlink.net",
    "yahoo.ca",
    "hotmail.com.au",
    "yahoo.com.au",
    "yahoo.co.uk",
    "gmaol.com",
    "yahoo.com.tw",
    "1gmail.com",
    "yahoo.com.br",
    "yahoo.com.ph",
    "yahoo.com.sg",
    "yahoo.com.mx",
    "yahoo.com.hk",
    "outlook.com.au",
    "hotmail.com",
    "agmail.com",
    "7gmail.com",
    "gmail",
    "yahoo",
    "outlook",
    "rr.com",
    "earthlink.net",
    "msn.com",
    "aol",
    "protonmail",
    "icloud.com",
    "mac.com",
  ];

  // Extracting domain from email_field
  const emailDomain = email_field.split("@")[1];
  const domainParts = emailDomain.split(".");
  const topLevelDomain = domainParts[domainParts.length - 1];

  // Checking if the email domain exactly matches one of the domains in stringList
  const isAllowedDomain =
    stringList.includes(emailDomain) || allowedDomains.includes(topLevelDomain);
  console.log(isAllowedDomain);
  console.log(optin_request_check);
  const raffleChecked = document.getElementById("optin_request_check").checked;
  console.log(raffleChecked);

  if (isValidDate(optin_date)) {
    // added allowed emails as a check
    if (
      (email_field.match(mailformat) && !isAllowedDomain) ||
      (email_field.match(mailformat) &&
        allowedUserEmails.includes(email_field)) ||
      allowedDomains.includes(emailDomain.split(".").slice(-1)[0])
    ) {
      if (raffleChecked) {
        if (
          name_field &&
          date_field &&
          event_field &&
          position_field &&
          participants_field &&
          comments_field
        ) {
          // Show loading message instead of immediate success
          $("#custom_form").html(
            "<center><p style='font-size:80%; color: #0066cc;'><strong>Submitting your request... Please wait.</strong></p></center>"
          );
          snapToTop();

          console.log("Form validation passed - submitting to Make.com webhooks");
          
          // Get the current URL for partner parameter - MOVED UP to define partner variable
          const urlParams = new URLSearchParams(window.location.search);
          const partner = urlParams.get("partner");
          console.log("partner", partner);
          
          // Log form data for debugging
          console.log("Form data:", {
            email: email_field,
            name: name_field,
            company: company_field,
            date: date_field,
            event: event_field,
            position: position_field,
            participants: participants_field,
            comments: comments_field,
            partner: partner,
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString()
          });

          // Create promise-based function for better error handling with retry mechanism
          function sendToMakeWebhook(url, data, description, retryCount = 0) {
            const maxRetries = 2;
            
            return new Promise((resolve, reject) => {
              console.log(`Sending request to ${description} (attempt ${retryCount + 1}/${maxRetries + 1}): ${url}`);
              console.log(`Request data length: ${data.length} characters`);
              
              const xhr = new XMLHttpRequest();
              let timeoutId;
              
              // Set up timeout (30 seconds)
              timeoutId = setTimeout(() => {
                xhr.abort();
                const errorMsg = `Timeout: ${description} request took too long (attempt ${retryCount + 1})`;
                console.error(errorMsg);
                
                if (retryCount < maxRetries) {
                  console.log(`Retrying ${description} in 2 seconds...`);
                  setTimeout(() => {
                    sendToMakeWebhook(url, data, description, retryCount + 1)
                      .then(resolve)
                      .catch(reject);
                  }, 2000);
                } else {
                  reject(new Error(errorMsg));
                }
              }, 30000);
              
              xhr.onload = function() {
                clearTimeout(timeoutId);
                console.log(`${description} response status: ${xhr.status}`);
                console.log(`${description} response: ${xhr.responseText}`);
                
                if (xhr.status >= 200 && xhr.status < 300) {
                  // Make.com webhooks typically return 200 with "Accepted" or similar
                  // This only means the webhook received the data, not that it processed successfully
                  const response = xhr.responseText;
                  console.log(`${description} webhook accepted data. Response: "${response}"`);
                  
                  // For Make.com, a 200 status is the best we can get for immediate confirmation
                  // The actual processing happens asynchronously in Make.com
                  resolve({
                    status: 'accepted',
                    response: response,
                    timestamp: new Date().toISOString()
                  });
                } else {
                  const errorMsg = `${description} HTTP error: ${xhr.status} - ${xhr.statusText}`;
                  console.error(errorMsg);
                  
                  if (retryCount < maxRetries && xhr.status >= 500) {
                    // Retry server errors
                    console.log(`Retrying ${description} in 2 seconds...`);
                    setTimeout(() => {
                      sendToMakeWebhook(url, data, description, retryCount + 1)
                        .then(resolve)
                        .catch(reject);
                    }, 2000);
                  } else {
                    reject(new Error(errorMsg));
                  }
                }
              };
              
              xhr.onerror = function() {
                clearTimeout(timeoutId);
                const errorMsg = `${description} network error - please check your internet connection (attempt ${retryCount + 1})`;
                console.error(errorMsg);
                
                if (retryCount < maxRetries) {
                  console.log(`Retrying ${description} in 2 seconds...`);
                  setTimeout(() => {
                    sendToMakeWebhook(url, data, description, retryCount + 1)
                      .then(resolve)
                      .catch(reject);
                  }, 2000);
                } else {
                  reject(new Error(errorMsg));
                }
              };
              
              xhr.onabort = function() {
                clearTimeout(timeoutId);
                const errorMsg = `${description} request was aborted (attempt ${retryCount + 1})`;
                console.error(errorMsg);
                
                if (retryCount < maxRetries) {
                  console.log(`Retrying ${description} in 2 seconds...`);
                  setTimeout(() => {
                    sendToMakeWebhook(url, data, description, retryCount + 1)
                      .then(resolve)
                      .catch(reject);
                  }, 2000);
                } else {
                  reject(new Error(errorMsg));
                }
              };
              
              try {
                console.log(`${description} - About to send XMLHttpRequest`);
                console.log(`${description} - URL: ${url}`);
                console.log(`${description} - Data preview: ${data.substring(0, 200)}...`);
                
                xhr.open("POST", url, true);
                xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                
                console.log(`${description} - XMLHttpRequest configured, sending data...`);
                xhr.send(data);
                console.log(`${description} - XMLHttpRequest.send() called successfully`);
              } catch (error) {
                clearTimeout(timeoutId);
                const errorMsg = `${description} failed to send: ${error.message}`;
                console.error(errorMsg);
                
                if (retryCount < maxRetries) {
                  console.log(`Retrying ${description} in 2 seconds...`);
                  setTimeout(() => {
                    sendToMakeWebhook(url, data, description, retryCount + 1)
                      .then(resolve)
                      .catch(reject);
                  }, 2000);
                } else {
                  reject(new Error(errorMsg));
                }
              }
            });
          }

          // Get the current URL for partner parameter - ALREADY DEFINED ABOVE
          // const urlParams = new URLSearchParams(window.location.search);
          // const partner = urlParams.get("partner");
          // console.log("partner", partner);
          
          // Add the 'partner' parameter to the API request if it exists
          const partnerParam = partner ? "&partner=" + partner : "";

          console.log("=== FORM FIELD VALUES ===");
          console.log("Raw field values:");
          console.log("  email_field:", email_field);
          console.log("  name_field:", name_field);
          console.log("  company_field:", company_field);
          console.log("  date_field:", date_field);
          console.log("  event_field:", event_field);
          console.log("  position_field:", position_field);
          console.log("  participants_field:", participants_field);
          console.log("  comments_field:", comments_field);
          console.log("Encoded values:");
          console.log("  optin_request_name:", optin_request_name);
          console.log("  optin_request:", optin_request);
          console.log("  optin_request_company:", optin_request_company);
          console.log("  optin_date:", optin_date);
          console.log("  optin_event:", optin_event);
          console.log("  optin_request_position:", optin_request_position);
          console.log("  optin_participants:", optin_participants);
          console.log("=== END FIELD VALUES ===");

          const requestData = 
            "optin_request_name=" +
              optin_request_name +
              "&optin_request=" +
              email_field +
              "&optin_request_company=" +
              optin_request_company +
              "&optin_date=" +
              optin_date +
              "&optin_first_position=" +
              optin_first_position +
              "&optin_request_phone=" +
              optin_request_phone +
              "&optin_event=" +
              optin_event +
              "&optin_participants=" +
              optin_participants +
              "&optin_request_twitter=" +
              optin_request_twitter +
              "&optin_request_comments=" +
              optin_location +
              optin_conference_type +
              optin_request_comments +
              optin_description +
              "&landing_url=" +
              landing_url +
              "&utm_source_partner=" +
              utm_source_partner +
              "&utm_medium_partner=" +
              utm_medium_partner +
              "&utm_content_partner=" +
              utm_content_partner +
              "&utm_term_partner=" +
              utm_term_partner +
              "&utm_campaign_partner=" +
              utm_campaign_partner +
              "&optin_btc_check=" +
              optin_btc_check +
              "&optin_request_check=" +
              optin_request_check +
              "&optin_request_position=" +
              optin_request_position +
              partnerParam +
              // Facebook CPC new-vs-returning ad-visitor tracking (see snippets/fb-visitor-tracking.liquid)
              (window.WBFBTracking && window.WBFBTracking.queryString ? window.WBFBTracking.queryString() : "");

              
          const new_legacy_request_body = 
              "optin_request_name=" +
              optin_request_name +
              "&optin_request=" +
              email_field +
              "&optin_request_company=" +
              optin_request_company +
              "&optin_date=" +
              optin_date +
              "&optin_first_position=" +
              optin_first_position +
              "&optin_request_phone=" +
              optin_request_phone +
              "&optin_event=" +
              optin_event +
              "&optin_participants=" +
              optin_participants +
              "&optin_request_twitter=" +
              optin_request_twitter +
              "&optin_request_comments=" +
              optin_location +
              optin_conference_type +
              optin_request_comments +
              optin_description +
              "&landing_url=" +
              landing_url +
              "&utm_source_partner=" +
              utm_source_partner +
              "&utm_medium_partner=" +
              utm_medium_partner +
              "&utm_content_partner=" +
              utm_content_partner +
              "&utm_term_partner=" +
              utm_term_partner +
              "&utm_campaign_partner=" +
              utm_campaign_partner +
              "&optin_btc_check=" +
              optin_btc_check + // Added BTC opt-in field
              "&optin_request_check=" +
              optin_request_check +
              "&optin_sms_optin=" +     
              optin_sms_optin +    // NEW
              "&optin_time=" +            
              optin_time +    // NEW
              "&optin_timezone=" +      
              optin_timezone   +    // NEW
              "&optin_product_variant=" +
              optin_product_variant + // NEW
              "&optin_datetime="  + 
              optin_datetime +
              "&optin_request_position=" +
              optin_request_position +
              "&collection_id=" + 
              encodeURIComponent(collection_id) + 
              "&optin_first_name="     + 
              encodeURIComponent(ship_first_name) +
              "&optin_last_name="      + 
              encodeURIComponent(ship_last_name) +
              "&optin_address1="       + 
              encodeURIComponent(ship_address1) +
              "&optin_address2="       + 
              encodeURIComponent(ship_address2) +
              "&optin_country="        + 
              encodeURIComponent(ship_country) +
              "&optin_city="           + 
              encodeURIComponent(ship_city) +
              "&optin_state="          + 
              encodeURIComponent(ship_state) +
              "&optin_zip="            + 
              encodeURIComponent(ship_zip) +
              "&optin_phone="          + 
              encodeURIComponent(ship_phone) +
              "&optin_organization="   + 
              encodeURIComponent(ship_organization) +
              "&draft_source="  + 
              encodeURIComponent(draft_source) +
              "&where_source="  + 
              encodeURIComponent(where_source) +
              "&line_items="    + 
              encodeURIComponent(line_items) +
              "&ship=" +        
              encodeURIComponent(ship) +
              "&partner=" +
              encodeURIComponent(partner) +
              partnerParam +
              // Facebook CPC new-vs-returning ad-visitor tracking (see snippets/fb-visitor-tracking.liquid)
              (window.WBFBTracking && window.WBFBTracking.queryString ? window.WBFBTracking.queryString() : "");


          console.log("=== WEBHOOK DATA DEBUG ===");
          console.log("Complete request data being sent:", requestData);
          console.log("Request data length:", requestData.length);
          console.log("Webhook URLs:");
          console.log("  1. Donation Form:", "https://hook.us1.make.com/e8ymv8giepth129f0yu2xfs85ztbi625");
          console.log("  2. Workshop JS no pipeline:", "https://hook.us1.make.com/4ocer96nrhok2tpum8m00svyixu3qz29");
          console.log("=== END DEBUG ===");

          // // Send to both webhooks with proper error handling
          // const webhook1Promise = sendToMakeWebhook(
          //   "https://hook.us1.make.com/e8ymv8giepth129f0yu2xfs85ztbi625",
          //   new_legacy_request_body,
          //   "Donation Form"
          // );
          
          // const webhook2Promise = sendToMakeWebhook(
          //   "https://hook.us1.make.com/4ocer96nrhok2tpum8m00svyixu3qz29",
          //   requestData,
          //   "Workshop JS no pipeline"
          // );



          // // Wait for both webhooks to complete
          // // Note: Make.com webhooks only confirm receipt, not successful processing
          // Promise.allSettled([webhook1Promise, webhook2Promise])
          //   .then(results => {
          //     console.log("Webhook submission attempts completed");
              
          //     let webhookSuccessCount = 0;
          //     let webhookErrors = [];
              
          //     results.forEach((result, index) => {
          //       const webhookName = index === 0 ? "Donation Form" : "Workshop JS no pipeline";
                
          //       if (result.status === 'fulfilled') {
          //         console.log(`${webhookName} webhook accepted data (received 200 response)`);
          //         webhookSuccessCount++;
          //       } else {
          //         console.error(`${webhookName} webhook failed to accept data:`, result.reason.message);
          //         webhookErrors.push(`${webhookName}: ${result.reason.message}`);
          //       }
          //     });
              
          //     // Show appropriate message based on webhook acceptance
          //     if (webhookSuccessCount > 0) {
          //       console.log(`${webhookSuccessCount}/2 webhooks accepted the submission data`);
                
          //       // Create unique reference ID for tracking
          //       const referenceId = `WS${Date.now()}${Math.random().toString(36).substr(2, 4).toUpperCase()}`;
                
          //       // Show simplified status message 
          //       let statusMessage;
          //       if (webhookSuccessCount === 2) {
          //         statusMessage = `
          //           <strong>✓ Your workshop request has been submitted successfully!</strong>
          //         `;
          //       } else {
          //         statusMessage = `
          //           <strong>⚠️ Your workshop request was submitted with a partial system issue.</strong><br><br>
          //           Please contact us at support@wipebook.com and mention there was a partial submission issue.<br><br>
          //           <strong>Reference ID:</strong> ${referenceId}<br><br>
          //           <small>Technical note: 1 of 2 submission systems confirmed receipt.</small>
          //         `;
                  
          //         // Log partial failure for debugging
          //         logFailureForDebugging({
          //           type: 'partial_webhook_failure',
          //           referenceId: referenceId,
          //           email: email_field,
          //           errors: webhookErrors,
          //           successCount: webhookSuccessCount,
          //           timestamp: new Date().toISOString(),
          //           userAgent: navigator.userAgent,
          //           url: window.location.href
          //         });
          //       }
                
          //       $("#custom_form").html(`<center><p style='font-size:80%; color: #0066cc;'>${statusMessage}</p></center>`);
          //       snapToTop();
          //       // Store reference ID in localStorage for potential follow-up
          //       try {
          //         localStorage.setItem('workshopSubmissionRef', JSON.stringify({
          //           referenceId: referenceId,
          //           email: email_field,
          //           timestamp: new Date().toISOString(),
          //           webhookSuccessCount: webhookSuccessCount
          //         }));
          //       } catch (e) {
          //         console.log("Could not store reference in localStorage:", e);
          //       }
                
          //       // Handle redirect logic after a brief delay to let user see the message
          //       setTimeout(() => {
          //         handleSuccessfulSubmission();
          //       }, 2000);
                
          //     } else {
          //       // Both webhooks failed to accept data - clear connection/network issue
          //       console.error("All webhooks failed to accept data:", webhookErrors);
                
          //       logFailureForDebugging({
          //         type: 'complete_webhook_failure',
          //         email: email_field,
          //         errors: webhookErrors,
          //         formData: {
          //           name: name_field,
          //           company: company_field,
          //           date: date_field,
          //           event: event_field,
          //           position: position_field,
          //           participants: participants_field
          //         },
          //         timestamp: new Date().toISOString(),
          //         userAgent: navigator.userAgent,
          //         url: window.location.href,
          //         connection: navigator.connection ? navigator.connection.effectiveType : "unknown"
          //       });
                
          //       $("#custom_form").html(`
          //         <center>
          //           <p style='font-size:80%; color: red;'>
          //             <strong>❌ Submission Failed</strong><br><br>
          //             We were unable to submit your workshop request due to a technical issue.<br>
          //             This could be due to network connectivity or server problems.<br><br>
          //             <strong>Please try again in a few minutes, or email us directly at:</strong><br>
          //             <a href="mailto:support@wipebook.com">support@wipebook.com</a><br><br>
          //             <small>Technical details: ${webhookErrors.join('; ')}</small>
          //           </p>
          //         </center>
          //       `);
          //     }
          //   })
          //   .catch(error => {
          //     // This shouldn't happen with Promise.allSettled, but just in case
          //     console.error("Unexpected error in webhook processing:", error);
              
          //     logFailureForDebugging({
          //       type: 'unexpected_error',
          //       email: email_field,
          //       error: error.message,
          //       timestamp: new Date().toISOString(),
          //       userAgent: navigator.userAgent,
          //       url: window.location.href
          //     });
              
          //     $("#custom_form").html(`
          //       <center>
          //         <p style='font-size:80%; color: red;'>
          //           <strong>❌ An unexpected error occurred</strong><br><br>
          //           Please try again or contact support@wipebook.com<br><br>
          //           <small>Error details: ${error.message}</small>
          //         </p>
          //       </center>
          //     `);
          //   });

          // Send to webhook (single)
const webhook1Promise = sendToMakeWebhook(
  "https://hook.us1.make.com/bdi25c9bh24jx9qj71jo55y863i7uk7k",
  new_legacy_request_body,
  "Donation Form"
);

const buildWorkshopTyUrl = () => {
  const tyUrl = new URL("https://wipebook.com/pages/new-partnership-thank-you");
  const currentParams = new URLSearchParams(window.location.search);

  // Prefer form-captured UTM values; fallback to existing URL params when present.
  const utmSource = $("#utm_source_partner").val() || currentParams.get("utm_source") || "";
  const utmMedium = $("#utm_medium_partner").val() || currentParams.get("utm_medium") || "";
  const utmCampaign = $("#utm_campaign_partner").val() || currentParams.get("utm_campaign") || "";
  const utmContent = $("#utm_content_partner").val() || currentParams.get("utm_content") || "";
  const utmTerm = $("#utm_term_partner").val() || currentParams.get("utm_term") || "";

  if (utmSource) tyUrl.searchParams.set("utm_source", utmSource);
  if (utmMedium) tyUrl.searchParams.set("utm_medium", utmMedium);
  if (utmCampaign) tyUrl.searchParams.set("utm_campaign", utmCampaign);
  if (utmContent) tyUrl.searchParams.set("utm_content", utmContent);
  if (utmTerm) tyUrl.searchParams.set("utm_term", utmTerm);

  const partnerValue = partner || currentParams.get("partner") || "";
  if (partnerValue) tyUrl.searchParams.set("partner", partnerValue);

  // Preserve common ad click IDs so attribution remains intact after redirect.
  [
    "gclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "ttclid",
    "msclkid",
    "li_fat_id",
    "twclid"
  ].forEach((key) => {
    const value = currentParams.get(key);
    if (value) tyUrl.searchParams.set(key, value);
  });

  return tyUrl.toString();
};

const redirectToWorkshopTyPage = () => {
  const tyDestination = buildWorkshopTyUrl();
  console.log("Redirecting workshop submission to TY page:", tyDestination);
  window.location.assign(tyDestination);
};

// Wait for webhook to complete
Promise.allSettled([webhook1Promise])
  .then(results => {
    console.log("Webhook submission attempt completed");

    const result = results[0];
    const webhookName = "Donation Form";

    if (result.status === "fulfilled") {
      console.log(`${webhookName} webhook accepted data (received 200 response)`);

      // Create unique reference ID for tracking (optional, still useful)
      const referenceId = `WS${Date.now()}${Math.random().toString(36).substr(2, 4).toUpperCase()}`;

      try {
        localStorage.setItem(
          "workshopSubmissionRef",
          JSON.stringify({
            referenceId,
            email: email_field,
            timestamp: new Date().toISOString(),
            webhookSuccessCount: 1
          })
        );
      } catch (e) {
        console.log("Could not store reference in localStorage:", e);
      }

      redirectToWorkshopTyPage();

    } else {
      const webhookError = `${webhookName}: ${result.reason?.message || "Unknown error"}`;
      console.error(`${webhookName} webhook failed to accept data:`, result.reason);

      logFailureForDebugging({
        type: "complete_webhook_failure",
        email: email_field,
        errors: [webhookError],
        formData: {
          name: name_field,
          company: company_field,
          date: date_field,
          event: event_field,
          position: position_field,
          participants: participants_field
        },
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href,
        connection: navigator.connection ? navigator.connection.effectiveType : "unknown"
      });

      redirectToWorkshopTyPage();
    }
  })
  .catch(error => {
    // still okay to keep as a safety net
    console.error("Unexpected error in webhook processing:", error);

    logFailureForDebugging({
      type: "unexpected_error",
      email: email_field,
      error: error.message,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href
    });

    redirectToWorkshopTyPage();
  });

          // Function to log failures for debugging (sends to a separate logging webhook)
          function logFailureForDebugging(errorData) {
            try {
              console.log("Logging failure for debugging:", errorData);
              
              const debugXhr = new XMLHttpRequest();
              debugXhr.open("POST", "https://webhook.site/unique-url-for-debugging", true); // Replace with actual debug webhook
              debugXhr.setRequestHeader("Content-type", "application/json");
              
              // Don't block the UI if debug logging fails
              debugXhr.onerror = function() {
                console.log("Debug logging failed (non-critical)");
              };
              
              debugXhr.send(JSON.stringify(errorData));
            } catch (debugError) {
              console.log("Debug logging error (non-critical):", debugError);
            }
          }

          function getWorkshopDecision() {
            const optinDate = new Date(optin_date);
            const today = new Date();
            const next3Weeks = new Date(today.getTime() + 13 * 24 * 60 * 60 * 1000);

            const teacherNoBtc =
              optin_request_position.includes("Teacher") && optin_btc_check === "NA";

            const meetsStandardCriteria =
              Number(optin_participants) > 20 &&
              optin_request_position !== "Non-Educator" &&
              optin_request_comments !== "Students" &&
              optinDate >= next3Weeks;

            if (teacherNoBtc || meetsStandardCriteria || partner) {
              return "approved";
            }

            return "denied";
          }

          // Function to handle successful submission redirect logic
          function handleSuccessfulSubmission() {
            // today's date + 3 weeks
            showDonationAgreement();
            var today = new Date();
            var next3Weeks = new Date(today.getTime() + 13 * 24 * 60 * 60 * 1000);
            console.log("CUTOFFDATE:" + next3Weeks);

            // Convert optin_date to a comparable format
            var optin_date_convert = new Date(optin_date);
            console.log("EVENTDATE:" + optin_date_convert);

            // Redirect logic
            let redirectUrl = `https://wipebook.com/agreement?approved=${email_field}`;
            
            // Add UTM parameters to preserve campaign tracking
            const utmSource = $("#utm_source_partner").val() || 'partners';
            const utmMedium = $("#utm_medium_partner").val() || 'workshops';
            const utmCampaign = $("#utm_campaign_partner").val() || '';
            const utmContent = $("#utm_content_partner").val() || 'agreement';
            const utmTerm = $("#utm_term_partner").val() || '';
            
            redirectUrl += `&utm_source=${encodeURIComponent(utmSource)}`;
            redirectUrl += `&utm_medium=${encodeURIComponent(utmMedium)}`;
            if (utmCampaign) redirectUrl += `&utm_campaign=${encodeURIComponent(utmCampaign)}`;
            redirectUrl += `&utm_content=${encodeURIComponent(utmContent)}`;
            if (utmTerm) redirectUrl += `&utm_term=${encodeURIComponent(utmTerm)}`;
            
            if (partner) {
              redirectUrl += `&partner=${partner}`;
            }

            // Check if the participant is a Teacher and did not opt in for BTC
            if (
              optin_request_position.includes("Teacher") && // Check if position contains "Teacher"
              // optin_btc_check === "No" // Check if BTC opt-in is "No"
              optin_btc_check === "" || optin_btc_check === "None of the above"
            ) {
              // Do not provide a direct link for Teachers who did not opt in for BTC
              console.log(
                "No direct link provided: Teacher did not opt in for BTC."
              );
              window.open(redirectUrl, '_blank'); // Open in new tab if all conditions are met

              // Handle this case (e.g., show a message or redirect to a different page)
            } else {
              // Proceed with the existing validation logic
              if (
                Number(optin_participants) > 20 && // Check if participants > 20
                optin_request_position !== "Non-Educator" && // Check if position is not "Non-Educator"
                optin_request_comments !== "Students" && // Check if audience is not "Students"
                optin_date_convert >= next3Weeks // Check if the date is within the next 3 weeks
              ) {
              // CHECK HERE
              $("#custom_form").html(`
                <div class="page-width" style="padding-top: 20px; font-family: 'Quicksand', sans-serif;">
                  <p style="text-align: center; font-weight: 700; color: green; font-size: 18px; margin-bottom: 30px;">
                    Thanks for applying, you will receive an automated SMS from us within the hour. If you don't receive one, please email us at support@wipebook.com.
                  </p>
                </div>
              `);

                // window.open(redirectUrl, '_blank'); // Open in new tab if all conditions are met
              } 
              
              else if (partner) {
                // Redirect for partner-specific logic
                // window.open(redirectUrl, '_blank'); // Open in new tab for partner logic
                $("#custom_form").html(`
                <div class="page-width" style="padding-top: 20px; font-family: 'Quicksand', sans-serif;">
                  <p style="text-align: center; font-weight: 700; color: green; font-size: 18px; margin-bottom: 30px;">
                    Thanks for applying, you will receive an automated SMS from us within the hour. If you don't receive one, please email us at support@wipebook.com.
                  </p>
                </div>
              `);
              } else {
                // Handle cases where conditions are not met
                console.log("Conditions not met for direct link.");
              }
            }
          }
        } else {
          console.log();

          $("#custom_form_error").html(
            "<center><p style='font-size:80%;'> <strong>Please complete the missing fields. </strong> </p></center>"
          );
        }
      } else {
        $("#custom_form_error").html(
          "<center><p style='font-size:80%; color:red;'> <strong>Thank you for your interest. To qualify for a free set of Wipebook flipcharts, you must agree to raffle a flipchart set to your attendees. If you’re unable to do this, we won’t be able to provide the flipcharts. <br></br> Thanks for understanding.</strong> </p></center>"
        );
      }
    } else {
      $("#custom_form_error").html(
        "<p style='font-size:80%;color:red;'> <strong>There is an issue with the email provided. Please add a valid work email. (i.e Email contains special character, avoid personal emails such as gmail, hotmail, etc). For more assistance please contact support@wipebook.com.</strong> </p>"
      );

      //INSERT THE POST REQUEST TO ADD TO DB ANYWAYS

      if (email_field.match(mailformat)) {
        const xhttp = new XMLHttpRequest();
        xhttp.onload = function () {
          console.log(xhttp.responseText);
        };

        let fullName = optin_request_name; // Replace this with your actual variable

        const names = fullName.split("%20");
        const firstName = names[0];
        const lastName = names[names.length - 1];

        console.log(`First name: ${firstName}`);
        console.log(`Last name: ${lastName}`);

        // firstName and lastName now contain the split name
        console.log(firstName + "|"); // Outputs: Frank
        console.log(lastName); // Outputs: Bouchard

        // goes to Contact Sync workflow
        xhttp.open(
          "POST",
          "https://hook.us1.make.com/wfjw095lwzcf4v3s5j4g4ud2low5kt5p"
        );
        xhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xhttp.send(
          "first_name=" +
            firstName +
            "&last_name=" +
            lastName +
            "&optin_request=" +
            email_field +
            "&optin_request_company=" +
            optin_request_company +
            "&optin_date=" +
            optin_date +
            "&position=" +
            optin_request_position +
            "&optin_request_phone=" +
            optin_request_phone +
            "&optin_event=" +
            optin_event +
            "&optin_participants=" +
            optin_participants +
            "&optin_request_twitter=" +
            optin_request_twitter +
            "&optin_request_comments=" +
            optin_location +
            optin_conference_type +
            optin_request_comments +
            optin_description +
            "&landing_url=" +
            landing_url +
            "&utm_source=" +
            utm_source_partner +
            "&utm_medium=" +
            utm_medium_partner +
            "&utm_campaign=" +
            utm_campaign_partner +
            "&utm_content=" +
            utm_content_partner +
            "&utm_term=" +
            utm_term_partner +
            "&optin_btc_check=" +
            optin_btc_check + // Added BTC opt-in field
            "&optin_request_check=" +
            optin_request_check +
            // "&multiple_event_checkbox=" +
            // multiEventChecked + // Send the new checkbox value
            "&customer_type=duplicate_personal&optin_request_position=" +
            optin_request_position
        );
      }
    }
  } else {
    $("#custom_form_error").html(
      "<center><p style='font-size:80%;'> <strong>There is an issue with your date format.</strong> </p></center>"
    );
  }
}
// Test function to verify connectivity and browser compatibility
function testWorkshopFormConnectivity() {
  console.log("Testing workshop form connectivity...");
  
  // Log browser capabilities
  console.log("Browser info:", {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    online: navigator.onLine,
    connection: navigator.connection ? navigator.connection.effectiveType : "unknown",
    cookieEnabled: navigator.cookieEnabled,
    doNotTrack: navigator.doNotTrack,
    language: navigator.language
  });
  
  // Test basic XMLHttpRequest functionality
  try {
    const testXhr = new XMLHttpRequest();
    console.log("XMLHttpRequest available: true");
    
    // Test webhook connectivity with a simple HEAD request
    testXhr.open("HEAD", "https://hook.us1.make.com/kimrsnp3sa6j12hle66k1yctg9mdwj38", true);
    testXhr.timeout = 10000;
    
    testXhr.onload = function() {
      console.log("Webhook connectivity test - Status:", testXhr.status);
      if (testXhr.status === 200 || testXhr.status === 405) { // 405 is expected for HEAD request
        console.log("✅ Webhook connectivity: PASSED");
      } else {
        console.log("⚠️ Webhook connectivity: QUESTIONABLE - Status", testXhr.status);
      }
    };
    
    testXhr.onerror = function() {
      console.log("❌ Webhook connectivity: FAILED - Network error");
    };
    
    testXhr.ontimeout = function() {
      console.log("❌ Webhook connectivity: FAILED - Timeout");
    };
    
    testXhr.send();
    
  } catch (error) {
    console.log("❌ XMLHttpRequest test failed:", error);
  }
  
  // Test jQuery availability
  if (typeof $ !== 'undefined') {
    console.log("✅ jQuery available: true");
  } else {
    console.log("❌ jQuery available: false");
  }
  
  // Test form fields availability
  const testFields = [
    'optin_request',
    'optin_request_name', 
    'optin_request_company',
    'optin_date',
    'optin_event',
    'optin_request_position',
    'optin_participants',
    'optin_request_comments'
  ];
  
  testFields.forEach(fieldId => {
    const field = document.getElementById(fieldId);
    if (field) {
      console.log(`✅ Field ${fieldId}: found`);
    } else {
      console.log(`❌ Field ${fieldId}: missing`);
    }
  });
  
  console.log("Workshop form connectivity test completed. Check console for results.");
}

// Test function to verify Make.com webhooks are responding
function testMakeWebhooks() {
  console.log("Testing Make.com webhook connectivity...");
  
  const webhooks = [
    {
      name: "Workshop Additional Field Pre-Req",
      url: "https://hook.us1.make.com/kimrsnp3sa6j12hle66k1yctg9mdwj38"
    },
    {
      name: "Workshop JS no pipeline", 
      url: "https://hook.us1.make.com/4ocer96nrhok2tpum8m00svyixu3qz29"
    }
  ];
  
  webhooks.forEach((webhook, index) => {
    console.log(`Testing ${webhook.name}...`);
    
    const xhr = new XMLHttpRequest();
    xhr.timeout = 15000;
    
    xhr.onload = function() {
      console.log(`${webhook.name} - Status: ${xhr.status}`);
      console.log(`${webhook.name} - Response: ${xhr.responseText}`);
      
      if (xhr.status >= 200 && xhr.status < 300) {
        console.log(`✅ ${webhook.name}: RESPONDING`);
      } else {
        console.log(`⚠️ ${webhook.name}: QUESTIONABLE (Status ${xhr.status})`);
      }
    };
    
    xhr.onerror = function() {
      console.log(`❌ ${webhook.name}: NETWORK ERROR`);
    };
    
    xhr.ontimeout = function() {
      console.log(`❌ ${webhook.name}: TIMEOUT`);
    };
    
    // Send a simple test payload
    xhr.open("POST", webhook.url, true);
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.send("test=connectivity_check&timestamp=" + Date.now());
  });
}

// Add test function to window for easy access in browser console
if (typeof window !== 'undefined') {
  window.testWorkshopFormConnectivity = testWorkshopFormConnectivity;
  window.testMakeWebhooks = testMakeWebhooks;
}

function ajax_mathreps_contest(str10) {
  var utm_campaign = document.getElementById("utm_campaign").value;
  var utm_content = document.getElementById("utm_content").value;
  var utm_medium = document.getElementById("utm_medium").value;
  var utm_source = document.getElementById("utm_source").value;
  var utm_term = document.getElementById("utm_term").value;
  var first_n = document.getElementById("first_n").value;
  var last_n = document.getElementById("last_n").value;
  var job = document.getElementById("job").value;
  var optin_request = document.getElementById("optin_request").value.trim();
  var collectionid = document.getElementById("collectionid").value;
  // var count=document.getElementById('count').value;
  var twitter = "";
  var landing_url = document.getElementById("landing_url_pop").value;
  var optin_event = document.getElementById("optin_event").value;
  var optin_product = document.getElementById("optin_product").value; // Retrieve the selected product value
  var email_field = optin_request;

  const stringList = [
    "gmx.com",
    "suddenlink.net",
    "cogeco.ca",
    "rr.com",
    "centurylink.net",
    "centurytel.net",
    "cs.com",
    "accesscomm.ca",
    "blackgold.ca",
    "icloud.com",
    "mac.com",
    "hotmail.fr",
    "me.com",
    "hotmail.ca",
    "aim.com",
    "shaw.ca",
    "rogers.com",
    "sympatico.ca",
    "videotron.ca",
    "live.com",
    "verizon.net",
    "yahoo.de",
    "telusplanet.net",
    "live.ca",
    "rocketmail.com",
    "xplornet.ca",
    "ymail.com",
    "yahoo.fr",
    "xtra.co.nz",
    "telus.net",
    "gmai.com",
    "sasktel.net",
    "prodigy.net",
    "email.com",
    "eastlink.ca",
    "mail.com",
    "gmail.co",
    "mailbox.org",
    "protonmail.com",
    "hotmil.com",
    "hormail.com",
    "gmaul.com",
    "yahoo.se",
    "yahoo.co",
    "gmailcom.com",
    "ns.sympatico.ca",
    "gmail.com",
    "comcast.net",
    "yahoo.com",
    "hotmail.com",
    "aol.com",
    "outlook.com",
    "hotmail.co.uk",
    "msn.com",
    "earthlink.net",
    "yahoo.ca",
    "hotmail.com.au",
    "yahoo.com.au",
    "yahoo.co.uk",
    "gmaol.com",
    "yahoo.com.tw",
    "1gmail.com",
    "yahoo.com.br",
    "yahoo.com.ph",
    "yahoo.com.sg",
    "yahoo.com.mx",
    "yahoo.com.hk",
    "outlook.com.au",
    "hotmail.com",
    "agmail.com",
    "7gmail.com",
    "gmail",
    "yahoo",
    "outlook",
    "rr.com",
    "earthlink.net",
    "msn.com",
    "aol",
    "protonmail",
    "icloud.com",
    "mac.com",
  ];

  // Extracting domain from email_field
  const emailDomain = email_field.split("@")[1];
  const domainParts = emailDomain.split(".");
  const topLevelDomain = domainParts[domainParts.length - 1];

  // Checking if the email domain exactly matches one of the domains in stringList
  const isAllowedDomain =
    stringList.includes(emailDomain) || allowedDomains.includes(topLevelDomain);

  if (first_n && last_n && job && optin_request) {
    // var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    var mailformat =
      /^(?!.*['"])\w+(?:['.-]?\w+)*@\w+(?:['.-]?\w+)*(\.\w{2,})+$/;
    // Matches scsc.school

    if (optin_request.match(mailformat)) {
      // added allowed emails as a check
      if (
        (email_field.match(mailformat) && !isAllowedDomain) ||
        (email_field.match(mailformat) &&
          allowedUserEmails.includes(email_field)) ||
        allowedDomains.includes(emailDomain.split(".").slice(-1)[0])
      ) {
        const xhttp = new XMLHttpRequest();
        xhttp.onload = function () {
          // document.getElementById("confirmation_contest").style.display =
          //   "inline";
          // console.log("updated to inline");
          document.getElementById("custom_form_out").innerHTML =
            "<center><div style='padding:20px; font-size:20px;'><strong>" +
            optin_request +
            "</strong> will be sent contest results & discount information.</div></center>";
        };
        // Mathrep Contest [Denied]
        xhttp.open(
          "POST",
          "https://hook.us1.make.com/faw6c3xh7wm4s2b2i3f84tm3vk64d4r8"
        );
        xhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xhttp.send(
          "optin_request=" +
            optin_request +
            "&optin_event=" +
            optin_event +
            "&twitter=" +
            twitter +
            "&collectionid=" +
            collectionid +
            "&job=" +
            job +
            "&first_n=" +
            first_n +
            "&last_n=" +
            last_n +
            "&utm_campaign=" +
            utm_campaign +
            "&utm_source=" +
            utm_source +
            "&utm_medium=" +
            utm_medium +
            "&utm_content=" +
            utm_content +
            "&utm_term=" +
            utm_term +
            "&landing_url=" +
            landing_url +
            "&optin_product=" +
            optin_product
        );
      } else {
        $("#custom_form_error_out").html(
          "<p style='font-size:80%;color:red;'> <strong>There is an issue with the email provided. Please add a valid work email. (i.e Email contains special character, avoid personal emails such as gmail, hotmail, etc). For more assistance please contact support@wipebook.com.</strong> </p>"
        );

        //INSERT THE POST REQUEST TO ADD TO DB ANYWAYS

        if (email_field.match(mailformat)) {
          const xhttp = new XMLHttpRequest();
          xhttp.onload = function () {
            console.log(xhttp.responseText);
          };

          const firstName = first_n;
          const lastName = last_n;

          console.log(
            "first_name=" +
              firstName +
              "&last_name=" +
              lastName +
              "&optin_request=" +
              email_field +
              "&optin_event=" +
              optin_event +
              "&position=" +
              job +
              "&landing_url=" +
              landing_url +
              "&utm_campaign=" +
              utm_campaign +
              "&utm_source=" +
              utm_source +
              "&utm_medium=" +
              utm_medium +
              "&utm_content=" +
              utm_content +
              "&optin_request_position=" +
              job
          );
          console.log(`Last name: ${lastName}`);

          // firstName and lastName now contain the split name
          console.log(firstName + "|"); // Outputs: Frank
          console.log(lastName); // Outputs: Bouchard

          // goes to Contact Sync workflow
          xhttp.open(
            "POST",
            "https://hook.us1.make.com/wfjw095lwzcf4v3s5j4g4ud2low5kt5p"
          );
          xhttp.setRequestHeader(
            "Content-type",
            "application/x-www-form-urlencoded"
          );
          xhttp.send(
            "first_name=" +
              firstName +
              "&last_name=" +
              lastName +
              "&optin_request=" +
              email_field +
              "&optin_event=" +
              optin_event +
              "&position=" +
              job +
              "&landing_url=" +
              landing_url +
              "&utm_campaign=" +
              utm_campaign +
              "&utm_source=" +
              utm_source +
              "&utm_medium=" +
              utm_medium +
              "&utm_content=" +
              utm_content +
              "&optin_request_position=" +
              job +
              "&customer_type=duplicate_personal" +
              "&optin_product=" +
              optin_product
          );
        }
      }
    } else {
      document.getElementById("custom_form_error_out").innerHTML =
        "<div style='padding:20px; font-size:20px;'><center><p style='font-size:80%;'> <strong>There is an issue with your email format.</strong> </p></center></div>";
    }
  } else {
    document.getElementById("custom_form_error_out").innerHTML =
      "<div style='padding:20px; font-size:20px;'><center><p style='font-size:80%;'> <strong>Please complete all fields.</strong> </p></center></div>";
  }
}

function ajax_approved_mathreps_contest(str10) {
  var utm_campaign = document.getElementById("utm_campaign").value;
  var utm_content = document.getElementById("utm_content").value;
  var utm_medium = document.getElementById("utm_medium").value;
  var utm_source = document.getElementById("utm_source").value;
  var utm_term = document.getElementById("utm_term").value;
  var first_n = document.getElementById("first_n").value;
  var last_n = document.getElementById("last_n").value;
  var job = document.getElementById("job").value;
  var optin_request = document.getElementById("optin_request").value.trim();
  var collectionid = document.getElementById("collectionid").value;
  // var count=document.getElementById('count').value;
  var twitter = "";
  var landing_url = document.getElementById("landing_url_pop").value;
  var optin_event = document.getElementById("optin_event").value;
  var optin_product = document.getElementById("optin_product").value; // Retrieve the selected product value
  var email_field = optin_request;

  // Extract the values from the URL
  var approved_mathrep = GetURLParameter("approved_mathrep");
  var customerid = GetURLParameter("customer");

  console.log("approved_mathrep", approved_mathrep);
  console.log("customerid,", customerid);

  const stringList = [
    "gmx.com",
    "suddenlink.net",
    "cogeco.ca",
    "rr.com",
    "centurylink.net",
    "centurytel.net",
    "cs.com",
    "accesscomm.ca",
    "blackgold.ca",
    "icloud.com",
    "mac.com",
    "hotmail.fr",
    "me.com",
    "hotmail.ca",
    "aim.com",
    "shaw.ca",
    "rogers.com",
    "sympatico.ca",
    "videotron.ca",
    "live.com",
    "verizon.net",
    "yahoo.de",
    "telusplanet.net",
    "live.ca",
    "rocketmail.com",
    "xplornet.ca",
    "ymail.com",
    "yahoo.fr",
    "xtra.co.nz",
    "telus.net",
    "gmai.com",
    "sasktel.net",
    "prodigy.net",
    "email.com",
    "eastlink.ca",
    "mail.com",
    "gmail.co",
    "mailbox.org",
    "protonmail.com",
    "hotmil.com",
    "hormail.com",
    "gmaul.com",
    "yahoo.se",
    "yahoo.co",
    "gmailcom.com",
    "ns.sympatico.ca",
    "gmail.com",
    "comcast.net",
    "yahoo.com",
    "hotmail.com",
    "aol.com",
    "outlook.com",
    "hotmail.co.uk",
    "msn.com",
    "earthlink.net",
    "yahoo.ca",
    "hotmail.com.au",
    "yahoo.com.au",
    "yahoo.co.uk",
    "gmaol.com",
    "yahoo.com.tw",
    "1gmail.com",
    "yahoo.com.br",
    "yahoo.com.ph",
    "yahoo.com.sg",
    "yahoo.com.mx",
    "yahoo.com.hk",
    "outlook.com.au",
    "hotmail.com",
    "agmail.com",
    "7gmail.com",
    "gmail",
    "yahoo",
    "outlook",
    "rr.com",
    "earthlink.net",
    "msn.com",
    "aol",
    "protonmail",
    "icloud.com",
    "mac.com",
  ];

  // Extracting domain from email_field
  const emailDomain = email_field.split("@")[1];
  const domainParts = emailDomain.split(".");
  const topLevelDomain = domainParts[domainParts.length - 1];

  // Checking if the email domain exactly matches one of the domains in stringList
  const isAllowedDomain =
    stringList.includes(emailDomain) || allowedDomains.includes(topLevelDomain);

  if (first_n && last_n && job && optin_request) {
    // var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    var mailformat =
      /^(?!.*['"])\w+(?:['.-]?\w+)*@\w+(?:['.-]?\w+)*(\.\w{2,})+$/;
    // Matches scsc.school

    if (optin_request.match(mailformat)) {
      // added allowed emails as a check
      if (
        (email_field.match(mailformat) && !isAllowedDomain) ||
        (email_field.match(mailformat) &&
          allowedUserEmails.includes(email_field)) ||
        allowedDomains.includes(emailDomain.split(".").slice(-1)[0])
      ) {
        const xhttp = new XMLHttpRequest();
        xhttp.onload = function () {
          // document.getElementById("confirmation_contest").style.display =
          //   "inline";
          // console.log("updated to inline");
          document.getElementById("custom_form_out").innerHTML =
            "<center><div style='padding:20px; font-size:20px;'><strong>" +
            optin_request +
            "</strong> will be sent contest results & discount information.</div></center>";
        };
        // Mathrep Contest [Approved]
        xhttp.open(
          "POST",
          "https://hook.us1.make.com/vs68i3qnd9e0qbjxwbkts7mr67rlju94"
        );
        xhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xhttp.send(
          "optin_request=" +
            optin_request +
            "&optin_event=" +
            optin_event +
            "&twitter=" +
            twitter +
            "&collectionid=" +
            collectionid +
            "&job=" +
            job +
            "&first_n=" +
            first_n +
            "&last_n=" +
            last_n +
            "&utm_campaign=" +
            utm_campaign +
            "&utm_source=" +
            utm_source +
            "&utm_medium=" +
            utm_medium +
            "&utm_content=" +
            utm_content +
            "&utm_term=" +
            utm_term +
            "&landing_url=" +
            landing_url +
            "&optin_product=" +
            optin_product +
            "&approved_mathrep=" +
            approved_mathrep +
            "&customerid=" +
            customerid
        );
      } else {
        $("#custom_form_error_out").html(
          "<p style='font-size:80%;color:red;'> <strong>There is an issue with the email provided. Please add a valid work email. (i.e Email contains special character, avoid personal emails such as gmail, hotmail, etc). For more assistance please contact support@wipebook.com.</strong> </p>"
        );

        //INSERT THE POST REQUEST TO ADD TO DB ANYWAYS

        if (email_field.match(mailformat)) {
          const xhttp = new XMLHttpRequest();
          xhttp.onload = function () {
            console.log(xhttp.responseText);
          };

          const firstName = first_n;
          const lastName = last_n;

          console.log(
            "first_name=" +
              firstName +
              "&last_name=" +
              lastName +
              "&optin_request=" +
              email_field +
              "&optin_event=" +
              optin_event +
              "&position=" +
              job +
              "&landing_url=" +
              landing_url +
              "&utm_campaign=" +
              utm_campaign +
              "&utm_source=" +
              utm_source +
              "&utm_medium=" +
              utm_medium +
              "&utm_content=" +
              utm_content +
              "&optin_request_position=" +
              job
          );
          console.log(`Last name: ${lastName}`);

          // firstName and lastName now contain the split name
          console.log(firstName + "|"); // Outputs: Frank
          console.log(lastName); // Outputs: Bouchard

          // goes to Contact Sync workflow
          xhttp.open(
            "POST",
            "https://hook.us1.make.com/wfjw095lwzcf4v3s5j4g4ud2low5kt5p"
          );
          xhttp.setRequestHeader(
            "Content-type",
            "application/x-www-form-urlencoded"
          );
          xhttp.send(
            "first_name=" +
              firstName +
              "&last_name=" +
              lastName +
              "&optin_request=" +
              email_field +
              "&optin_event=" +
              optin_event +
              "&position=" +
              job +
              "&landing_url=" +
              landing_url +
              "&utm_campaign=" +
              utm_campaign +
              "&utm_source=" +
              utm_source +
              "&utm_medium=" +
              utm_medium +
              "&utm_content=" +
              utm_content +
              "&optin_request_position=" +
              job +
              "&customer_type=duplicate_personal" +
              "&optin_product=" +
              optin_product +
              "&approved_mathrep=" +
              approved_mathrep +
              "&customerid=" +
              customerid
          );
        }
      }
    } else {
      document.getElementById("custom_form_error_out").innerHTML =
        "<div style='padding:20px; font-size:20px;'><center><p style='font-size:80%;'> <strong>There is an issue with your email format.</strong> </p></center></div>";
    }
  } else {
    document.getElementById("custom_form_error_out").innerHTML =
      "<div style='padding:20px; font-size:20px;'><center><p style='font-size:80%;'> <strong>Please complete all fields.</strong> </p></center></div>";
  }
}

function ajax_contestz(str10, bypassEmailTypoCheck) {
  var utm_campaign = document.getElementById("utm_campaign").value;
  var utm_content = document.getElementById("utm_content").value;
  var utm_medium = document.getElementById("utm_medium").value;
  var utm_source = document.getElementById("utm_source").value;
  var utm_term = document.getElementById("utm_term").value;
  var first_n = document.getElementById("first_n").value;
  var last_n = document.getElementById("last_n").value;
  var job = document.getElementById("job").value;
  var optin_request = document.getElementById("optin_request").value.trim();
  var collectionid = document.getElementById("collectionid").value;
  // var count=document.getElementById('count').value;
  var twitter = "";
  var landing_url = document.getElementById("landing_url_pop").value;
  var optin_event = document.getElementById("optin_event").value;

  var email_field = optin_request;

  // Invalid email-domain check: warn (but never block) on a likely typo'd
  // domain/TLD. Show "Use <fix>" / "Submit anyway"; either re-runs this bypassed.
  if (!bypassEmailTypoCheck) {
    var emailTypoSuggestion = suggestEmailTypoCorrection(optin_request);
    if (emailTypoSuggestion) {
      showEmailTypoWarning(optin_request, emailTypoSuggestion, function () {
        ajax_contestz("", true);
      });
      return;
    }
  }
  // Proceeding to submit — clear any lingering typo warning.
  var priorTypoWarning = document.getElementById("email_typo_warning");
  if (priorTypoWarning && priorTypoWarning.parentNode) {
    priorTypoWarning.parentNode.removeChild(priorTypoWarning);
  }

  const stringList = [
    "gmx.com",
    "suddenlink.net",
    "cogeco.ca",
    "rr.com",
    "centurylink.net",
    "centurytel.net",
    "cs.com",
    "accesscomm.ca",
    "blackgold.ca",
    "icloud.com",
    "mac.com",
    "hotmail.fr",
    "me.com",
    "hotmail.ca",
    "aim.com",
    "shaw.ca",
    "rogers.com",
    "sympatico.ca",
    "videotron.ca",
    "live.com",
    "verizon.net",
    "yahoo.de",
    "telusplanet.net",
    "live.ca",
    "rocketmail.com",
    "xplornet.ca",
    "ymail.com",
    "yahoo.fr",
    "xtra.co.nz",
    "telus.net",
    "gmai.com",
    "sasktel.net",
    "prodigy.net",
    "email.com",
    "eastlink.ca",
    "mail.com",
    "gmail.co",
    "mailbox.org",
    "protonmail.com",
    "hotmil.com",
    "hormail.com",
    "gmaul.com",
    "yahoo.se",
    "yahoo.co",
    "gmailcom.com",
    "ns.sympatico.ca",
    "gmail.com",
    "comcast.net",
    "yahoo.com",
    "hotmail.com",
    "aol.com",
    "outlook.com",
    "hotmail.co.uk",
    "msn.com",
    "earthlink.net",
    "yahoo.ca",
    "hotmail.com.au",
    "yahoo.com.au",
    "yahoo.co.uk",
    "gmaol.com",
    "yahoo.com.tw",
    "1gmail.com",
    "yahoo.com.br",
    "yahoo.com.ph",
    "yahoo.com.sg",
    "yahoo.com.mx",
    "yahoo.com.hk",
    "outlook.com.au",
    "hotmail.com",
    "agmail.com",
    "7gmail.com",
    "gmail",
    "yahoo",
    "outlook",
    "rr.com",
    "earthlink.net",
    "msn.com",
    "aol",
    "protonmail",
    "icloud.com",
    "mac.com",
  ];

  // Extracting domain from email_field
  const emailDomain = email_field.split("@")[1];
  const domainParts = emailDomain.split(".");
  const topLevelDomain = domainParts[domainParts.length - 1];

  // Checking if the email domain exactly matches one of the domains in stringList
  const isAllowedDomain =
    stringList.includes(emailDomain) || allowedDomains.includes(topLevelDomain);

  if (first_n && last_n && job && optin_request) {
    // var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    var mailformat =
      /^(?!.*['"])\w+(?:['.-]?\w+)*@\w+(?:['.-]?\w+)*(\.\w{2,})+$/;
    // Matches scsc.school

    if (optin_request.match(mailformat)) {
      // added allowed emails as a check
      if (
        (email_field.match(mailformat) && !isAllowedDomain) ||
        (email_field.match(mailformat) &&
          allowedUserEmails.includes(email_field)) ||
        allowedDomains.includes(emailDomain.split(".").slice(-1)[0])
      ) {
        const xhttp = new XMLHttpRequest();
        xhttp.onload = function () {
          document.getElementById("confirmation_contest").style.display =
            "inline";
          console.log("updated to inline");
          document.getElementById("custom_form_out").innerHTML =
            "<center><div style='padding:20px; font-size:20px;'><strong>" +
            optin_request +
            "</strong> will be sent contest results & discount information.</div></center>";
        };
        xhttp.open(
          "POST",
          "https://hook.us1.make.com/b3v5nveq1rwji6qbv8tefmqgt7kyrq2e"
        );
        xhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        // Facebook CPC new-vs-returning ad-visitor tracking (see snippets/fb-visitor-tracking.liquid)
        var fbTracking = "";
        if (window.WBFBTracking && window.WBFBTracking.getData) {
          var fb = window.WBFBTracking.getData();
          // Prefer WBFBTracking's landing_url: it refreshes on every tagged ad arrival,
          // unlike the first-visit-only cookie that #landing_url_pop is sourced from.
          if (fb.landing_url) {
            landing_url = encodeURIComponent(fb.landing_url);
          }
          fbTracking =
            "&fbclid=" + encodeURIComponent(fb.fbclid || "") +
            "&fbc=" + encodeURIComponent(fb.fbc || "") +
            "&fbp=" + encodeURIComponent(fb.fbp || "") +
            "&visitor_id=" + encodeURIComponent(fb.visitor_id || "") +
            "&visit_count=" + encodeURIComponent(fb.visit_count || "");
        }
        xhttp.send(
          "optin_request=" +
            optin_request +
            "&optin_event=" +
            optin_event +
            "&twitter=" +
            twitter +
            "&collectionid=" +
            collectionid +
            "&job=" +
            job +
            "&first_n=" +
            first_n +
            "&last_n=" +
            last_n +
            "&utm_campaign=" +
            utm_campaign +
            "&utm_source=" +
            utm_source +
            "&utm_medium=" +
            utm_medium +
            "&utm_content=" +
            utm_content +
            "&utm_term=" +
            utm_term +
            "&landing_url=" +
            landing_url +
            fbTracking
        );
      } else {
        $("#custom_form_error_out").html(
          "<p style='font-size:80%;color:red;'> <strong>There is an issue with the email provided. Please add a valid work email. (i.e Email contains special character, avoid personal emails such as gmail, hotmail, etc). For more assistance please contact support@wipebook.com.</strong> </p>"
        );

        //INSERT THE POST REQUEST TO ADD TO DB ANYWAYS

        if (email_field.match(mailformat)) {
          const xhttp = new XMLHttpRequest();
          xhttp.onload = function () {
            console.log(xhttp.responseText);
          };

          const firstName = first_n;
          const lastName = last_n;

          console.log(
            "first_name=" +
              firstName +
              "&last_name=" +
              lastName +
              "&optin_request=" +
              email_field +
              "&optin_event=" +
              optin_event +
              "&position=" +
              job +
              "&landing_url=" +
              landing_url +
              "&utm_campaign=" +
              utm_campaign +
              "&utm_source=" +
              utm_source +
              "&utm_medium=" +
              utm_medium +
              "&utm_content=" +
              utm_content +
              "&optin_request_position=" +
              job
          );
          console.log(`Last name: ${lastName}`);

          // firstName and lastName now contain the split name
          console.log(firstName + "|"); // Outputs: Frank
          console.log(lastName); // Outputs: Bouchard

          // goes to Contact Sync workflow
          xhttp.open(
            "POST",
            "https://hook.us1.make.com/wfjw095lwzcf4v3s5j4g4ud2low5kt5p"
          );
          xhttp.setRequestHeader(
            "Content-type",
            "application/x-www-form-urlencoded"
          );
          xhttp.send(
            "first_name=" +
              firstName +
              "&last_name=" +
              lastName +
              "&optin_request=" +
              email_field +
              "&optin_event=" +
              optin_event +
              "&position=" +
              job +
              "&landing_url=" +
              landing_url +
              "&utm_campaign=" +
              utm_campaign +
              "&utm_source=" +
              utm_source +
              "&utm_medium=" +
              utm_medium +
              "&utm_content=" +
              utm_content +
              "&optin_request_position=" +
              job +
              "&customer_type=duplicate_personal"
          );
        }
      }
    } else {
      document.getElementById("custom_form_error_out").innerHTML =
        "<div style='padding:20px; font-size:20px;'><center><p style='font-size:80%;'> <strong>There is an issue with your email format.</strong> </p></center></div>";
    }
  } else {
    document.getElementById("custom_form_error_out").innerHTML =
      "<div style='padding:20px; font-size:20px;'><center><p style='font-size:80%;'> <strong>Please complete all fields.</strong> </p></center></div>";
  }
}

// Basic Levenshtein edit distance, used to catch mistyped mailbox providers.
function levenshteinDistance(a, b) {
  a = a || "";
  b = b || "";
  var m = a.length;
  var n = b.length;
  if (m === 0) return n;
  if (n === 0) return m;
  var prev = [];
  var curr = [];
  for (var j = 0; j <= n; j++) prev[j] = j;
  for (var i = 1; i <= m; i++) {
    curr[0] = i;
    for (var k = 1; k <= n; k++) {
      var cost = a.charAt(i - 1) === b.charAt(k - 1) ? 0 : 1;
      curr[k] = Math.min(prev[k] + 1, curr[k - 1] + 1, prev[k - 1] + cost);
    }
    for (var t = 0; t <= n; t++) prev[t] = curr[t];
  }
  return prev[n];
}

// Returns a likely-corrected email (e.g. "jo@gmial.con" -> "jo@gmail.com") when
// the domain/TLD looks mistyped, or null when nothing looks wrong. This only
// suggests — it never decides on the user's behalf.
function suggestEmailTypoCorrection(email) {
  if (typeof email !== "string") return null;
  email = email.trim();
  var at = email.lastIndexOf("@");
  if (at < 1 || at === email.length - 1) return null;

  var local = email.slice(0, at);
  var domain = email.slice(at + 1).toLowerCase();
  if (domain.indexOf(".") === -1) return null;

  var correctedDomain = domain;

  // 1) Fix a mistyped top-level domain. Applies to any domain, incl. business.
  var tldFixes = {
    // -> .com
    con: "com", conm: "com", comm: "com", coom: "com", ccom: "com",
    ckm: "com", cim: "com", cin: "com", cid: "com", cpm: "com", clm: "com",
    c0m: "com", cvm: "com", cmm: "com", xcom: "com",
    vom: "com", xom: "com", dom: "com", som: "com", fom: "com",
    ocm: "com", cmo: "com", cm: "com", om: "com",
    // -> .net
    ner: "net", nte: "net", ndt: "net", nett: "net", nrt: "net",
    nwt: "net", nef: "net", neg: "net",
    // -> .org
    orf: "org", ogr: "org", orh: "org", ort: "org", ord: "org",
    prg: "org", irg: "org", "0rg": "org", rog: "org", orgg: "org",
    orgn: "org",
    // -> .edu
    eud: "edu", edi: "edu", edy: "edu", wdu: "edu", esu: "edu",
    exu: "edu", ecu: "edu", deu: "edu", eduu: "edu",
    // -> .gov
    gpv: "gov", giv: "gov", "g0v": "gov", gvo: "gov", goc: "gov", gob: "gov",
    // -> .info
    ifno: "info", inof: "info", inro: "info", ingo: "info",
    // -> .biz
    bis: "biz", bix: "biz", bic: "biz",
    // -> .io
    oi: "io", i0: "io",
  };
  var parts = correctedDomain.split(".");
  var tld = parts[parts.length - 1];
  if (tldFixes.hasOwnProperty(tld)) {
    parts[parts.length - 1] = tldFixes[tld];
    correctedDomain = parts.join(".");
  }

  // 2) Fix a mistyped popular mailbox provider (gmial.com -> gmail.com). Skip
  // domains we already know are valid so real addresses are left untouched.
  var knownGoodDomains = {
    "gmail.com": 1, "googlemail.com": 1, "yahoo.com": 1, "ymail.com": 1,
    "rocketmail.com": 1, "hotmail.com": 1, "outlook.com": 1, "live.com": 1,
    "msn.com": 1, "aol.com": 1, "aim.com": 1, "icloud.com": 1, "me.com": 1,
    "mac.com": 1, "protonmail.com": 1, "comcast.net": 1, "gmx.com": 1,
    "mail.com": 1, "email.com": 1,
    // Real country-code provider domains — leave these untouched.
    "yahoo.ca": 1, "yahoo.fr": 1, "yahoo.de": 1, "yahoo.se": 1,
    "yahoo.co.uk": 1, "yahoo.com.au": 1, "hotmail.ca": 1, "hotmail.fr": 1,
    "hotmail.co.uk": 1, "hotmail.com.au": 1, "live.ca": 1, "outlook.com.au": 1,
    "aol.ca": 1, "icloud.ca": 1,
  };
  if (!knownGoodDomains.hasOwnProperty(correctedDomain)) {
    var providers = [
      "gmail.com", "yahoo.com", "hotmail.com", "outlook.com", "aol.com",
      "icloud.com", "live.com", "msn.com", "protonmail.com", "comcast.net",
    ];
    var best = null;
    var bestDist = 99;
    for (var p = 0; p < providers.length; p++) {
      var d = levenshteinDistance(correctedDomain, providers[p]);
      if (d < bestDist) {
        bestDist = d;
        best = providers[p];
      }
    }
    if (best && bestDist >= 1 && bestDist <= 2) {
      correctedDomain = best;
    }
  }

  if (correctedDomain !== domain) {
    return local + "@" + correctedDomain;
  }
  return null;
}

// Renders the "Did you mean ...?" prompt just above the Enter button with two
// one-click paths: use the correction, or submit the email unchanged. Inserted
// as a sibling so the form inputs are never removed from the DOM.
function showEmailTypoWarning(originalEmail, correctedEmail, resubmit) {
  var anchor = document.getElementById("submit_email");
  if (!anchor || !anchor.parentNode) return;

  var existing = document.getElementById("email_typo_warning");
  if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

  var box = document.createElement("div");
  box.id = "email_typo_warning";
  box.style.cssText =
    "margin:10px auto; max-width:320px; padding:10px 12px; border:1px solid #f0c36d; background:#fffbe6; border-radius:6px; font-family:'Quicksand', sans-serif; font-size:13px; color:#5c4b1a; text-align:center;";

  var msg = document.createElement("div");
  msg.style.cssText = "margin-bottom:8px; line-height:1.35;";
  msg.innerHTML =
    "You entered <strong></strong>. Did you mean <strong></strong>?";
  var strongs = msg.getElementsByTagName("strong");
  strongs[0].textContent = originalEmail;
  strongs[1].textContent = correctedEmail;

  var useBtn = document.createElement("a");
  useBtn.href = "javascript:void(0)";
  useBtn.textContent = "Use " + correctedEmail;
  useBtn.style.cssText =
    "display:inline-block; margin:4px; padding:8px 12px; background:#019FE9; color:#fff; border-radius:4px; text-decoration:none; font-weight:bold; cursor:pointer;";
  useBtn.onclick = function () {
    var field = document.getElementById("optin_request");
    if (field) field.value = correctedEmail;
    if (box.parentNode) box.parentNode.removeChild(box);
    if (typeof resubmit === "function") resubmit();
  };

  var anywayBtn = document.createElement("a");
  anywayBtn.href = "javascript:void(0)";
  anywayBtn.textContent = "Submit anyway";
  anywayBtn.style.cssText =
    "display:inline-block; margin:4px; padding:8px 12px; background:#eeeeee; color:#333333; border-radius:4px; text-decoration:none; font-weight:bold; cursor:pointer;";
  anywayBtn.onclick = function () {
    if (box.parentNode) box.parentNode.removeChild(box);
    if (typeof resubmit === "function") resubmit();
  };

  box.appendChild(msg);
  box.appendChild(useBtn);
  box.appendChild(anywayBtn);
  anchor.parentNode.insertBefore(box, anchor);
}

// Inline variant of the typo prompt for on-page forms (e.g. the quote/draft
// form) rather than popups. Renders a small note directly under the given email
// field with "Use this" / "...anyway" links. Same never-block behavior.
function showEmailTypoWarningInline(fieldId, originalEmail, correctedEmail, resubmit, skipScroll) {
  var field = document.getElementById(fieldId);
  if (!field || !field.parentNode) return;

  // One warning box per field, so multiple fields can be flagged at once.
  var warningId = "email_typo_warning_inline_" + fieldId;
  var existing = document.getElementById(warningId);
  if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

  var box = document.createElement("div");
  box.id = warningId;
  box.style.cssText =
    "margin:6px 0 10px; padding:8px 10px; border-left:3px solid #f0ad4e; background:#fcf8e3; border-radius:3px; font-family:'Quicksand', sans-serif; font-size:13px; color:#8a6d3b; text-align:left; line-height:1.5;";

  var msg = document.createElement("span");
  msg.innerHTML = "Did you mean <strong></strong>? ";
  msg.getElementsByTagName("strong")[0].textContent = correctedEmail;

  var useBtn = document.createElement("a");
  useBtn.href = "javascript:void(0)";
  useBtn.textContent = "Use this";
  useBtn.style.cssText =
    "color:#019FE9; font-weight:bold; text-decoration:underline; cursor:pointer;";
  useBtn.onclick = function () {
    field.value = correctedEmail;
    if (box.parentNode) box.parentNode.removeChild(box);
    if (typeof resubmit === "function") resubmit();
  };

  var sep = document.createElement("span");
  sep.textContent = "  ·  ";

  var anywayBtn = document.createElement("a");
  anywayBtn.href = "javascript:void(0)";
  anywayBtn.textContent = "Use what I typed";
  anywayBtn.style.cssText =
    "color:#8a6d3b; text-decoration:underline; cursor:pointer;";
  anywayBtn.onclick = function () {
    if (box.parentNode) box.parentNode.removeChild(box);
    if (typeof resubmit === "function") resubmit();
  };

  box.appendChild(msg);
  box.appendChild(useBtn);
  box.appendChild(sep);
  box.appendChild(anywayBtn);
  // Place the note directly beneath the email field.
  field.parentNode.insertBefore(box, field.nextSibling);
  if (!skipScroll) {
    try { box.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e) {}
  }
}

function ajax_contest_v2(str10, bypassEmailTypoCheck) {
  var utm_campaign = document.getElementById("utm_campaign").value;
  var utm_content = document.getElementById("utm_content").value;
  var utm_term = document.getElementById("utm_term").value;
  var utm_medium = document.getElementById("utm_medium").value;
  var utm_source = document.getElementById("utm_source").value;
  var first_n = document.getElementById("first_n").value;
  var last_n = document.getElementById("last_n").value;
  var job = document.getElementById("job").value;
  var optin_request = document.getElementById("optin_request").value;
  var collectionid = document.getElementById("collectionid").value;
  var twitter = "";
  var landing_url = document.getElementById("landing_url_pop").value;
  var optin_event = document.getElementById("optin_event").value;

  var email_field = optin_request;

  // Invalid email-domain check: warn (but never block) on a likely typo'd
  // domain/TLD. Show the suggestion with "Use <fix>" / "Submit anyway" instead
  // of submitting; either button re-runs this with the check bypassed.
  if (!bypassEmailTypoCheck) {
    var emailTypoSuggestion = suggestEmailTypoCorrection(optin_request);
    if (emailTypoSuggestion) {
      showEmailTypoWarning(optin_request, emailTypoSuggestion, function () {
        ajax_contest_v2("", true);
      });
      return;
    }
  }
  // Proceeding to submit — clear any lingering typo warning.
  var priorTypoWarning = document.getElementById("email_typo_warning");
  if (priorTypoWarning && priorTypoWarning.parentNode) {
    priorTypoWarning.parentNode.removeChild(priorTypoWarning);
  }

  const stringList = [
    "gmx.com",
    "suddenlink.net",
    "cogeco.ca",
    "rr.com",
    "centurylink.net",
    "centurytel.net",
    "cs.com",
    "accesscomm.ca",
    "blackgold.ca",
    "icloud.com",
    "mac.com",
    "hotmail.fr",
    "me.com",
    "hotmail.ca",
    "aim.com",
    "shaw.ca",
    "rogers.com",
    "sympatico.ca",
    "videotron.ca",
    "live.com",
    "verizon.net",
    "yahoo.de",
    "telusplanet.net",
    "live.ca",
    "rocketmail.com",
    "xplornet.ca",
    "ymail.com",
    "yahoo.fr",
    "xtra.co.nz",
    "telus.net",
    "gmai.com",
    "sasktel.net",
    "prodigy.net",
    "email.com",
    "eastlink.ca",
    "mail.com",
    "gmail.co",
    "mailbox.org",
    "protonmail.com",
    "hotmil.com",
    "hormail.com",
    "gmaul.com",
    "yahoo.se",
    "yahoo.co",
    "gmailcom.com",
    "ns.sympatico.ca",
    "gmail.com",
    "comcast.net",
    "yahoo.com",
    "hotmail.com",
    "aol.com",
    "outlook.com",
    "hotmail.co.uk",
    "msn.com",
    "earthlink.net",
    "yahoo.ca",
    "hotmail.com.au",
    "yahoo.com.au",
    "yahoo.co.uk",
    "gmaol.com",
    "yahoo.com.tw",
    "1gmail.com",
    "yahoo.com.br",
    "yahoo.com.ph",
    "yahoo.com.sg",
    "yahoo.com.mx",
    "yahoo.com.hk",
    "outlook.com.au",
    "hotmail.com",
    "agmail.com",
    "7gmail.com",
    "gmail",
    "yahoo",
    "outlook",
    "rr.com",
    "earthlink.net",
    "msn.com",
    "aol",
    "protonmail",
    "icloud.com",
    "mac.com",
  ];

  // Extracting domain from email_field
  const emailDomain = email_field.split("@")[1];
  const domainParts = emailDomain.split(".");
  const topLevelDomain = domainParts[domainParts.length - 1];

  // Checking if the email domain exactly matches one of the domains in stringList
  const isAllowedDomain =
    stringList.includes(emailDomain) || allowedDomains.includes(topLevelDomain);

  if (first_n && last_n && job && optin_request) {
    var mailformat =
      /^(?!.*['"])\w+(?:['.-]?\w+)*@\w+(?:['.-]?\w+)*(\.\w{2,3})+$/;

    if (
      (email_field.match(mailformat) && !isAllowedDomain) ||
      (email_field.match(mailformat) &&
        allowedUserEmails.includes(email_field)) ||
      allowedDomains.includes(emailDomain.split(".").slice(-1)[0])
    ) {
      // Added allowed emails as a check
      if (
        (email_field.match(mailformat) && !isAllowedDomain) ||
        (email_field.match(mailformat) &&
          allowedUserEmails.includes(email_field)) ||
        allowedDomains.includes(emailDomain.split(".").slice(-1)[0])
      ) {
        sendFirstRequest({
          optin_request,
          twitter,
          collectionid,
          job,
          first_n,
          last_n,
          utm_campaign,
          utm_source,
          utm_medium,
          utm_content,
          utm_term,
          landing_url,
          optin_event,
        });
      } else {
        $("#custom_form_error_out").html(
          "<p style='font-size:70%;color:red;'> <strong> Please add a valid work email. (i.e Avoid personal emails such as gmail, hotmail, etc). For more assistance please contact support@wipebook.com.</strong> </p>"
        );

        // Insert the post request to add to DB anyways
        if (
          (email_field.match(mailformat) && !isAllowedDomain) ||
          (email_field.match(mailformat) &&
            allowedUserEmails.includes(email_field)) ||
          allowedDomains.includes(emailDomain.split(".").slice(-1)[0])
        ) {
          sendDuplicatePersonalRequest({
            first_n,
            last_n,
            email_field,
            job,
            landing_url,
            utm_campaign,
            utm_source,
            utm_medium,
            utm_content,
            utm_term,
            optin_event,
          });
        }
      }
    } else {
      document.getElementById("custom_form_error_out").innerHTML =
        "<div style='padding:20px; font-size:20px;'><center><p style='font-size:80%;'> <strong>There is an issue with your email format.</strong> </p></center></div>";
    }
  } else {
    document.getElementById("custom_form_error_out").innerHTML =
      "<div style='padding:20px; font-size:20px;'><center><p style='font-size:80%;'> <strong>Please complete all fields.</strong> </p></center></div>";
  }
}

function sendFirstRequest(data) {
  console.log;
  const xhttp = new XMLHttpRequest();

  xhttp.open(
    "POST",
    "https://hook.us1.make.com/ep8okzuhupn3bhee4a15eojx58aidh6p"
  );
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

        xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            let responseData = this.responseText;
            
            if (responseData.trim() === "Accepted") {
                document.getElementById("confirmation_contest").style.display = "inline";
                document.getElementById("custom_form_out").innerHTML = 
                    "<center>" +
                        "<h2 style='font-size:25px; text-transform:none;'>" +
                            "Winner will be chosen once the contest reaches " +
                            "<span style='color:green'>" + 20 + "</span> participants!" +
                        "</h2>" +
                        "<div style='padding-left:20px;padding-right:20px;'>" +
                            "<strong>" + data.optin_request + "</strong> will be sent contest results & discount information." +
                        "</div>" +
                    "</center>" +
                    "<br>";
            } else {
                // Handle other responses
                console.log("Unexpected response:", responseData);
                // You can choose to display an error message or handle it in another way
            }
        }
    };




  // Facebook CPC new-vs-returning ad-visitor tracking (see snippets/fb-visitor-tracking.liquid)
  let fbTracking = "";
  if (window.WBFBTracking && window.WBFBTracking.getData) {
    const fb = window.WBFBTracking.getData();
    // Prefer WBFBTracking's landing_url: it refreshes on every tagged ad arrival,
    // unlike the first-visit-only cookie that #landing_url_pop is sourced from.
    if (fb.landing_url) {
      data.landing_url = encodeURIComponent(fb.landing_url);
    }
    fbTracking =
      `&fbclid=${encodeURIComponent(fb.fbclid || "")}` +
      `&fbc=${encodeURIComponent(fb.fbc || "")}` +
      `&fbp=${encodeURIComponent(fb.fbp || "")}` +
      `&visitor_id=${encodeURIComponent(fb.visitor_id || "")}` +
      `&visit_count=${encodeURIComponent(fb.visit_count || "")}`;
  }

  xhttp.send(
    `optin_request=${data.optin_request}&optin_event=${data.optin_event}&twitter=${data.twitter}&collectionid=${data.collectionid}&job=${data.job}&first_n=${data.first_n}&last_n=${data.last_n}&utm_campaign=${data.utm_campaign}&utm_source=${data.utm_source}&utm_medium=${data.utm_medium}&utm_content=${data.utm_content}&utm_term=${data.utm_term}&landing_url=${data.landing_url}${fbTracking}`
  );

  document.getElementById("custom_form_out").innerHTML =
    '<br><center><span id="loading"><img src="https://cdn.shopify.com/s/files/1/0883/6332/files/default.gif?16331683254428815167" style="width: 50px;" /></span><center><br><br>';
}

function sendDuplicatePersonalRequest(data) {
  const xhttp = new XMLHttpRequest();
  xhttp.onload = function () {
    console.log(xhttp.responseText);
  };

  const firstName = data.first_n;
  const lastName = data.last_n;

  // goes to Contact Sync workflow
  xhttp.open(
    "POST",
    "https://hook.us1.make.com/wfjw095lwzcf4v3s5j4g4ud2low5kt5p"
  );
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

  xhttp.send(
    `first_name=${firstName}&last_name=${lastName}&optin_request=${data.email_field}&optin_event=${data.optin_event}&position=${data.job}&landing_url=${data.landing_url}&utm_campaign=${data.utm_campaign}&utm_source=${data.utm_source}&utm_medium=${data.utm_medium}&utm_content=${data.utm_content}&optin_request_position=${data.job}&customer_type=duplicate_personal`
  );
}

function ajax_conference(couponval) {
  var utm_campaign = document.getElementById("utm_campaign").value;
  var utm_content = document.getElementById("utm_content").value;
  var utm_term = document.getElementById("utm_term").value;
  var utm_medium = document.getElementById("utm_medium").value;
  var utm_source = document.getElementById("utm_source").value;
  var first_n = document.getElementById("first_n").value;
  var last_n = document.getElementById("last_n").value;
  var job = document.getElementById("job").value;
  var optin_request = document.getElementById("optin_request").value;
  var collectionid = document.getElementById("collectionid").value;
  var count = document.getElementById("count").value;
  var twitter = "";
  var landing_url = document.getElementById("landing_url_pop").value;
  var optin_event = document.getElementById("optin_event").value;

  if (first_n && last_n && job && optin_request) {
    // var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    var mailformat =
      /^(?!.*['"])\w+(?:['.-]?\w+)*@\w+(?:['.-]?\w+)*(\.\w{2,3})+$/;

    if (optin_request.match(mailformat)) {
      const xhttp = new XMLHttpRequest();
      xhttp.onload = function () {
        console.log("send sendinblue");
      };
      xhttp.open(
        "POST",
        "https://hook.us1.make.com/v0y78cz4lyktw2ssrnjpqo3c2efopt5y"
      );
      xhttp.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      xhttp.send(
        "optin_request=" +
          optin_request +
          "&optin_event=" +
          optin_event +
          "&twitter=" +
          twitter +
          "&collectionid=" +
          collectionid +
          "&job=" +
          job +
          "&first_n=" +
          first_n +
          "&last_n=" +
          last_n +
          "&utm_campaign=" +
          utm_campaign +
          "&utm_source=" +
          utm_source +
          "&utm_medium=" +
          utm_medium +
          "&utm_content=" +
          utm_content +
          "&utm_term=" +
          utm_term +
          "&landing_url=" +
          landing_url +
          "&product_field=" +
          couponval
      );
    } else {
      document.getElementById("custom_form_error_out").innerHTML =
        "<div style='padding:20px; font-size:20px;'><center><p style='font-size:80%;'> <strong>There is an issue with your email format.</strong> </p></center></div>";
    }
  } else {
    document.getElementById("custom_form_error_out").innerHTML =
      "<div style='padding:20px; font-size:20px;'><center><p style='font-size:80%;'> <strong>Please complete all fields.</strong> </p></center></div>";
  }
}

function ajax_quote(str10, acknowledgedEmailFields) {
  // Invalid email-domain check (inline) for this on-page quote/draft form.
  // Checks Billing (#email) and Shipping (#email_shipping) and shows a warning
  // under EVERY field with a likely typo at the same time. Once the user picks
  // "Use this" / "Use what I typed" for a field, it's acknowledged and only the
  // remaining flagged fields keep their warnings. Empty or absent fields are
  // skipped, so nothing is ever blocked.
  var acknowledged = acknowledgedEmailFields || [];
  var emailFieldsToCheck = ["email", "email_shipping"];
  var pendingTypoFields = [];
  for (var ei = 0; ei < emailFieldsToCheck.length; ei++) {
    var fid = emailFieldsToCheck[ei];
    var el = document.getElementById(fid);
    var suggestion =
      el && acknowledged.indexOf(fid) === -1
        ? suggestEmailTypoCorrection(el.value)
        : null;
    if (suggestion) {
      pendingTypoFields.push({ fieldId: fid, email: el.value, suggestion: suggestion });
    } else {
      // Field is fine, acknowledged, or absent — drop any stale warning under it.
      var staleWarning = document.getElementById("email_typo_warning_inline_" + fid);
      if (staleWarning && staleWarning.parentNode) {
        staleWarning.parentNode.removeChild(staleWarning);
      }
    }
  }
  if (pendingTypoFields.length) {
    for (var pi = 0; pi < pendingTypoFields.length; pi++) {
      (function (pending, isFirst) {
        showEmailTypoWarningInline(
          pending.fieldId,
          pending.email,
          pending.suggestion,
          function () {
            ajax_quote(str10, acknowledged.concat([pending.fieldId]));
          },
          !isFirst // only scroll to the first warning
        );
      })(pendingTypoFields[pi], pi === 0);
    }
    return;
  }

  $("#loading").show();

  $.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
      if (o[this.name] !== undefined) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }
        o[this.name].push(this.value || "");
      } else {
        o[this.name] = this.value || "";
      }
    });

    return o;
  };

  var email_field = $("#email").val();
  var phone_field = $("#phone_number").val();

  var country_field_shipping = $("#country_shipping").val();
  var organization_field_shipping = $("#organization_shipping").val();
  var firstname_field_shipping = $("#first-name_shipping").val();
  var lastname_field_shipping = $("#last-name_shipping").val();
  var position_field_shipping = $("#position_shipping").val();
  var address1_field_shipping = $("#address1_shipping").val();
  var city_field_shipping = $("#city_shipping").val();
  var province_field_shipping = $("#province_shipping").val() || $("#province_shipping_manual").val();
  var postal_field_shipping = $("#postal_shipping").val();

  var country_field = $("#country").val();
  var organization_field = $("#organization").val();
  var firstname_field = $("#first-name").val();
  var lastname_field = $("#last-name").val();
  var position_field = $("#position").val();
  var address1_field = $("#address1").val();
  var city_field = $("#city").val();
  var province_field = $("#province").val() || $("#province_manual").val();
  var postal_field = $("#postal").val();
  var owner_field = $("#owner").val();

  var tag = $("#draft_source").val();
  //alert('winballws');
  //alert('byebye');

  var draft_form_elements = $("form").serializeObject();
  console.log(draft_form_elements);
  console.log(owner_field);

  //var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
  if (email_field.match(mailformat)) {
    if (
      owner_field &&
      country_field &&
      organization_field &&
      firstname_field &&
      lastname_field &&
      position_field &&
      address1_field &&
      city_field &&
      province_field &&
      postal_field &&
      country_field_shipping &&
      organization_field_shipping &&
      firstname_field_shipping &&
      lastname_field_shipping &&
      position_field_shipping &&
      address1_field_shipping &&
      city_field_shipping &&
      province_field_shipping &&
      postal_field_shipping &&
      phone_field
    ) {
      console.log("no missing fields");
      // { firstName: 'Jean-Luc', lastName: 'Picard' }
      const filtered_array = Object.fromEntries(
        Object.entries(draft_form_elements).filter(([key]) =>
          key.includes("_item")
        )
      );

      const unique_array = Object.fromEntries(
        Object.entries(draft_form_elements).filter(([key]) =>
          key.includes("id_item")
        )
      );

      console.log(JSON.stringify(unique_array));

      const line_items = [];
      var counter = 0;
      var order_weight = 0;
      for (const [key, value] of Object.entries(unique_array)) {
        var keyloop = key;
        var key_quantity_item = value + "_quantity_item";
        var key_id_item = value + "_quantity_item";
        var key_discounted_item = value + "_discounted_item";
        var key_msrp_item = value + "_msrp_item";
        var key_weight_item = value + "_weight_item";
        var amount =
          filtered_array[key_discounted_item] *
          filtered_array[key_quantity_item];
        var off =
          filtered_array[key_msrp_item] - filtered_array[key_discounted_item];

        if (filtered_array[key_quantity_item] > 0) {
          if (keyloop.includes("_quantity_item")) {
            var quantity_item = value;
          } else {
            var quantity_item = 0;
          }
          if (keyloop.includes("_id_item")) {
            var id_item = value;
          } else {
            var id_item = 0;
          }
          if (keyloop.includes("_discount_item")) {
            var discount_item = value;
          } else {
            var discount_item = 0;
          }
          if (keyloop.includes("_discount_item")) {
            var discount_item = value;
          } else {
            var discount_item = 0;
          }
          if (keyloop.includes("_discount_item")) {
            var discount_item = value;
          } else {
            var discount_item = 0;
          }

             // Calculate percentage discount
            var discount_percentage = 0;
            if (filtered_array[key_msrp_item] > 0) {
              discount_percentage = Math.round((off / filtered_array[key_msrp_item]) * 100);
            }
            let item;
            if (tag === "draft_donation") {
              item = {
                variant_id: id_item,
                quantity: filtered_array[key_quantity_item],
                applied_discount: {
                  description: "Volume Discount",
                  value_type: "fixed_amount",
                  value: off,
                  amount: amount,
                  title: "Volume",
                },
              };
            } else {
              item = {
                variantId: 'gid://shopify/ProductVariant/' + id_item,
                quantity: parseInt(filtered_array[key_quantity_item], 10),
                appliedDiscount: {
                  description: "Volume Discount",
                  valueType: "PERCENTAGE",
                  value: discount_percentage,
                  amount: amount,
                  title: "Volume",
                },
              };
            }

          order_weight =
            filtered_array[key_quantity_item] *
              filtered_array[key_weight_item] +
            order_weight;

          line_items[counter] = item;

          counter = counter + 1;
        }
      }

      var line_items_send;
      console.log(line_items);
      line_items_send = '{"line_items":' + JSON.stringify(line_items) + "}";

      document.getElementById("line_items").value = line_items_send;

      // Escaped/single-line copy for embedding inside another JSON body
      // (e.g. body_html in a Make.com HTTP module)
      var line_items_safe = line_items_send
        .replace(/[\r\n]+/g, "")
        .replace(/"/g, '\\"');
      var line_items_safe_el = document.getElementById("line_items_safe");
      if (line_items_safe_el) {
        line_items_safe_el.value = line_items_safe;
      }
      document.getElementById("ship").value =
        Math.round(100 * (12 + 2.3 * order_weight)) / 100;

      console.log(order_weight + "lbs");
      document.getElementById("submit_form").submit();

      setTimeout(() => {
        window.scrollTo(0, 0);

        $("#ordering_space").html("");

        if (tag != "draft_donation") {
          $("#description_text").html(
            '<h2>Quotes for companies and educational institutions:</h2><br>Thank you for the request. Your quote  has been sent to our team and they should be sending you an email confirmation within the next day. If you have any questions, feel free to touch base with us at support@wipebook.com.<br><br><strong style="color: #ff0000;">We will send a quote within the next 48 hours. If you don&#39;t receive it, please reach out to us at sales@wipebook.com (some school boards block our emails)</strong><br><br><h2>Has your company or school board/district ordered before?</h2>If you are a new customer looking to provide a payment via a PO, please complete this additional form in order to confirm the required billing information:<br><br><a class="btn btn--fill btn--regular btn--color" style=" box-sizing: border-box; font-size: 14px; color: #fff; text-decoration: none; line-height: 2em; font-weight: bold; text-align: center; cursor: pointer; display: inline-block; border-radius: 5px; background-color: #019fe9; margin: 0; border-color: #019FE9; border-style: solid; border-width: 10px 0px;" href="https://forms.gle/eytTwVrzj3gWGuLk9" target="_blank" >Submit additional billing information</a><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>'

          );
        } else {
          $("#description_text").html(
            "<h2>Donation Agreement</h2><br>Thank you for the request. You should have received an automated confirmation email. If you you didn't receive this, please let us know at support@wipebook.com.<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>"
          );
        }
      }, 1000);
    } else {
      $("#loading").hide();
      $("#result").html(
        "<center><p style='font-size:80%;'> <strong>One of the fields is missing information. Please complete missing information.</strong> </p></center>"
      );

      console.log(
        "FIELDS:" +
          owner_field +
          "|" +
          country_field +
          "|" +
          organization_field +
          "|" +
          firstname_field +
          "|" +
          lastname_field +
          "|" +
          position_field +
          "|" +
          address1_field +
          "|" +
          city_field +
          "|" +
          province_field +
          "|" +
          postal_field +
          "|" +
          country_field_shipping +
          "|" +
          organization_field_shipping +
          "|" +
          firstname_field_shipping +
          "|" +
          lastname_field_shipping +
          "|" +
          position_field_shipping +
          "|" +
          address1_field_shipping +
          "|" +
          city_field_shipping +
          "|" +
          province_field_shipping +
          "|" +
          postal_field_shipping
      );
    }
  } else {
    $("#loading").hide();
    $("#result").html(
      "<center><p style='font-size:80%;'> <strong>There is an issue with your email format.</strong> </p></center>"
    );
  }
}

function ajax_province_shipping(str, str2) {
  var url = "https://wipebook.org/shopify/forms/country_shipping.php";
  //var url='https://wipebook.co/mail/country_shipping.php';
  var datastring = str;

  var dropdown_us =
    '<select style="width:200px;" id="province_shipping" name="province_shipping" class="input-xlarge" placeholder="State / Province / Region"><option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">District Of Columbia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PA">Pennsylvania</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option> <option value="AS">American Samoa</option><option value="GU">Guam</option><option value="MP">Northern Mariana Islands</option><option value="PR">Puerto Rico</option><option value="UM">United States Minor Outlying Islands</option><option value="VI">Virgin Islands</option><option value="AA">Armed Forces Americas</option><option value="AP">Armed Forces Pacific</option><option value="AE">Armed Forces Others</option></select>';
  var dropdown_other =
    '<input type="text" id="province_shipping" name="province_shipping" class="input-xlarge" placeholder="State / Province / Region">';
  var dropdown_ca =
    '<select style="width:200px;" id="province_shipping" name="province_shipping" class="input-xlarge" placeholder="State / Province / Region"><option value="AB">alberta</option><option value="BC">british columbia</option><option value="MB">manitoba</option><option value="NB">new brunswick</option><option value="NL">newfoundland and labrador</option><option value="NS">nova scotia</option><option value="NT">northwest territories</option><option value="NU">nunavut</option><option value="ON" selected="">ontario</option><option value="PE">prince edward island</option><option value="QC">quebec</option><option value="SK">saskatchewan</option><option value="YT">yukon</option></select>';

  if (str == "CA") {
    document.getElementById("province_field_shipping").innerHTML = dropdown_ca;
  }

  if (str == "US") {
    document.getElementById("province_field_shipping").innerHTML = dropdown_us;
  }

  if (str != "US" && str != "CA") {
    document.getElementById("province_field_shipping").innerHTML =
      dropdown_other;
  }

  if (typeof str2 !== "undefined") {
    document.getElementById("province_shipping").value = str2;
  }
}

function ajax_province(str) {
  var url = "https://wipebook.org/shopify/forms/country_social.php";
  //var url='https://wipebook.co/mail/country_social.php';
  var datastring = str;

  var dropdown_us =
    '<select style="width:200px;" id="province" name="province" class="input-xlarge" placeholder="State / Province / Region" onchange="autofill();"><option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">District Of Columbia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PA">Pennsylvania</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option> <option value="AS">American Samoa</option><option value="GU">Guam</option><option value="MP">Northern Mariana Islands</option><option value="PR">Puerto Rico</option><option value="UM">United States Minor Outlying Islands</option><option value="VI">Virgin Islands</option><option value="AA">Armed Forces Americas</option><option value="AP">Armed Forces Pacific</option><option value="AE">Armed Forces Others</option></select>';
  var dropdown_other =
    '<input type="text" id="province" name="province" class="input-xlarge" placeholder="State / Province / Region" onchange="autofill();">';
  var dropdown_ca =
    '<select style="width:200px;" id="province" name="province" class="input-xlarge" placeholder="State / Province / Region" onchange="autofill();"><option value="AB">alberta</option><option value="BC">british columbia</option><option value="MB">manitoba</option><option value="NB">new brunswick</option><option value="NL">newfoundland and labrador</option><option value="NS">nova scotia</option><option value="NT">northwest territories</option><option value="NU">nunavut</option><option value="ON" selected="">ontario</option><option value="PE">prince edward island</option><option value="QC">quebec</option><option value="SK">saskatchewan</option><option value="YT">yukon</option></select>';

  if (str == "CA") {
    document.getElementById("province_field").innerHTML = dropdown_ca;
  }

  if (str == "US") {
    document.getElementById("province_field").innerHTML = dropdown_us;
  }

  if (str != "US" && str != "CA") {
    document.getElementById("province_field").innerHTML = dropdown_other;
  }
}

function ajax_partner(str) {
  var email_field = $("#optin_request").val();

  var source = "partner";

  var sParam = "lnid";
  var valuelabel = GetURLParameter(sParam);
  var _this = this;
  var email_field = $("#optin_request").val();
  var name_field = $("#optin_request_name").val();
  var company_field = $("#optin_request_company").val();
  var phone_field = $("#optin_request_phone").val();
  var twitter_field = $("#optin_request_twitter").val();
  var comments_field = $("#optin_request_comments").val();
  var landing_url = $("#landing_url").val();

  var email_field = encodeURI(email_field);
  var name_field = encodeURI(name_field);
  var company_field = encodeURI(company_field);
  var phone_field = encodeURI(phone_field);
  var twitter_field = encodeURI(twitter_field);
  var comments_field = encodeURI(comments_field);

  // var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  var mailformat =
    /^(?!.*['"])\w+(?:['.-]?\w+)*@\w+(?:['.-]?\w+)*(\.\w{2,3})+$/;

  if (email_field.match(mailformat)) {
    document.getElementById("make_partner").submit();

    $("#custom_form").html(
      "<center><p style='font-size:80%;'> <strong>Thanks for applying! We will be contacting you back in the next day or two.</strong> </p></center>"
    );
  } else {
    $("#custom_form").html(
      "<center><p style='font-size:80%;'> <strong>There is an issue with your email format. </strong> </p></center>"
    );
  }
}

function ajax_out(str, bypassEmailTypoCheck) {
  var email_field = $("#optin_request").val();

  // Invalid email-domain check: warn (but never block) on a likely typo'd
  // domain/TLD before submitting. "Use <fix>" / "Submit anyway" each re-run
  // this with the check bypassed (preserving the original source `str`).
  if (!bypassEmailTypoCheck) {
    var emailTypoSuggestion = suggestEmailTypoCorrection(email_field);
    if (emailTypoSuggestion) {
      showEmailTypoWarning(email_field, emailTypoSuggestion, function () {
        ajax_out(str, true);
      });
      return;
    }
  }
  // Proceeding to submit — clear any lingering typo warning.
  var priorTypoWarning = document.getElementById("email_typo_warning");
  if (priorTypoWarning && priorTypoWarning.parentNode) {
    priorTypoWarning.parentNode.removeChild(priorTypoWarning);
  }

  if (email_field) {
    document.getElementById("make").submit();
  }

  var source = str;
  var _this = this;

  var product_field = $("#product_field").val();
  var coupon_email = $("#coupon_email").val();
  var landing_url = encodeURIComponent($("#landing_url_pop").val());

  var url =
    "https://wipebook.org/customers/add_email.php?source=" +
    source +
    "&email=" +
    email_field +
    "&coupon=" +
    coupon_email +
    "&landing_url=" +
    landing_url +
    "&product_id=" +
    product_field;

  //alert('secret passage way');

  $("#custom_form_out").html(
    "<img style='width:30px;' src='https://cdn.shopify.com/s/files/1/0883/6332/files/loading.gif?11508027098045112438'> <span id='custom_form_error_out'></span>"
  );

  // var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  var mailformat =
    /^(?!.*['"])\w+(?:['.-]?\w+)*@\w+(?:['.-]?\w+)*(\.\w{2,3})+$/;

  if (email_field.match(mailformat)) {
    //console.log("Valid email address!");

    $("#custom_form_out").html(
      "<center><p style='font-size:80%;'> Perfect, we will forward the information to <strong>" +
        email_field +
        "</strong>. </p></center><br>"
    );
  } else {
    $("#custom_form_out").html(
      " <center> <p style='font-size:80%;'>There was an error in your email format.  Refresh and try again.</p></center>"
    );
  }
}


function ggcontestajax(bypassEmailTypoCheck) {
  // Invalid email-domain check: warn (but never block) on a likely typo'd
  // domain/TLD before touching the button or sending. "Use <fix>" / "Submit
  // anyway" each re-run this with the check bypassed. Runs first so the button
  // isn't stuck on "Sending..." while the warning is shown.
  var emailFieldEl = document.getElementById("optin_request");
  var emailForTypoCheck = emailFieldEl ? emailFieldEl.value : "";
  if (!bypassEmailTypoCheck) {
    var emailTypoSuggestion = suggestEmailTypoCorrection(emailForTypoCheck);
    if (emailTypoSuggestion) {
      showEmailTypoWarning(emailForTypoCheck, emailTypoSuggestion, function () {
        ggcontestajax(true);
      });
      return;
    }
  }
  // Proceeding to submit — clear any lingering typo warning.
  var priorTypoWarning = document.getElementById("email_typo_warning");
  if (priorTypoWarning && priorTypoWarning.parentNode) {
    priorTypoWarning.parentNode.removeChild(priorTypoWarning);
  }

  // 1. Get the form and the enter button
  var form = document.getElementById("maker");
  var submitBtn = document.getElementById("submit_email");
  
  // 2. Change button text to show it's processing and prevent double-clicks
  submitBtn.innerText = "Sending...";
  submitBtn.style.pointerEvents = "none";

  // 3. Automatically gather all the data from the form fields
  var formData = new FormData(form);

  // 3b. Facebook CPC new-vs-returning ad-visitor tracking (see snippets/fb-visitor-tracking.liquid)
  if (window.WBFBTracking && window.WBFBTracking.getData) {
    var wbTrack = window.WBFBTracking.getData();
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term",
      "fbclid", "fbc", "fbp", "visitor_id", "visit_count", "landing_url"].forEach(function (k) {
      formData.set(k, wbTrack[k] || "");
    });
  }

  // 4. YOUR GOOGLE SCRIPT URL GOES HERE
  var googleScriptUrl = "https://hook.us1.make.com/76xmghudbbpc9wic6yz6x2v7sa5vxrt3";

  // 5. Send the data silently in the background
  fetch(googleScriptUrl, {
    method: 'POST',
    mode: 'no-cors', // CRITICAL: This prevents Google's strict security blocks (CORS)
    body: formData
  })
  .then(function() {
    // 6. What happens when it successfully sends:
    
    // Hide the form
    document.getElementById("custom_form_out").style.display = "none";
    
    // Show your hidden confirmation text
    var confirmationBox = document.getElementById("confirmation_contest");
    if (confirmationBox) {
      confirmationBox.style.display = "block";
    }
  })
  .catch(function(error) {
    // If something fails, let them try again
    console.error('Error!', error.message);
    submitBtn.innerText = "Error - Try Again";
    submitBtn.style.pointerEvents = "auto";
  });
}












function ajax_contest() {
  alert(
    "This contest link is expired. For further support, please contact support@wipebook.com. You will be redirected to our general weekly contest link for your chance to win."
  );
  window.location.href = "https://wipebook.com/contest";
}

function ajax_edu() {
  alert(
    "This form no longer exists, please contact support@wipebook.com. You will be redirected to our general education information page."
  );
  window.location.href = "https://wipebook.com/quotes";
}

function ajax_coupon() {
  alert(
    "This form no longer exists, please contact support@wipebook.com. You will be redirected to our general discount page."
  );
  window.location.href = "https://wipebook.com/?coupon=20";
}

